window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },

  /**
   * Constructs an object of key / value pairs out of the parameters of the query string
   *
   * @return {Object}
   */
  getQueryParams: function() {
    var queryString = location.search && location.search.substr(1) || '';
    var queryParams = {};

    queryString
      .split('&')
      .filter(function (element) {
        return element.length;
      })
      .forEach(function (paramValue) {
        var splitted = paramValue.split('=');

        if (splitted.length > 1) {
          queryParams[splitted[0]] = splitted[1];
        } else {
          queryParams[splitted[0]] = true;
        }
      });

    return queryParams;
  },

  /**
   * Constructs a version of the current URL with the passed in key value pair as part of the query string
   *
   * @param {String} key
   * @param {String} value
   * @param {String} uri - optional, defaults to window.location.href
   * @return {String}
   */
  getUrlWithUpdatedQueryStringParameter: function(key, value, uri) {
    var uri = uri != undefined ? uri : window.location.href;
    
    // remove the hash part before operating on the uri    
    var i = uri.indexOf('#');
    var hash = i === -1 ? ''  : uri.substr(i);
         uri = i === -1 ? uri : uri.substr(0, i);

    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        uri = uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
        uri = uri + separator + key + "=" + value;
    }
    return uri + hash;  // finally append the hash as well
  },

  /**
   * Constructs a version of the current URL with the passed in parameter key and associated value removed
   *
   * @param {String} key
   * @return {String}
   */
  getUrlWithRemovedQueryStringParameter: function(parameterKeyToRemove, uri) {
    var uri = uri != undefined ? uri : window.location.href,
        rtn = uri.split("?")[0],
        param,
        params_arr = [],
        queryString = (uri.indexOf("?") !== -1) ? uri.split("?")[1] : "";

    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === parameterKeyToRemove) {
                params_arr.splice(i, 1);
            }
        }
         if (params_arr.length > 0) { 
          rtn = rtn + "?" + params_arr.join("&");
        }
    }

    return rtn;
  },  

  /**
   * Check if we're running the theme inside the theme editor
   *
   * @return {bool}
   */
  isThemeEditor: function() {
    return location.href.match(/myshopify.com/) !== null && location.href.match(/theme_id/) !== null;
  },

  /**
   * Get the name of the correct 'transitionend' event for the browser we're in
   *
   * @return {string}
   */
  whichTransitionEnd: function() {
    var t;
    var el = document.createElement('fakeelement');
    var transitions = {
      'transition':'transitionend',
      'OTransition':'oTransitionEnd',
      'MozTransition':'transitionend',
      'WebkitTransition':'webkitTransitionEnd'
    };

    for(t in transitions){
      if( el.style[t] !== undefined ){
        return transitions[t];
      }
    }
  },

  /**
   * Adds user agent classes to the document to target specific browsers
   *
   */
  userAgentBodyClass: function() {
    var ua = navigator.userAgent,
        d = document.documentElement,
        classes = d.className;

    // Detect iOS (needed to disable zoom on form elements)
    // http://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
    if ( /iPad|iPhone|iPod/.test(ua) && !window.MSStream ) {
      classes += ' ua-ios';

      // Add class for version of iOS
      var matches = ua.match(/((\d+_?){2,3})\slike\sMac\sOS\sX/);
      if ( matches ) {
        classes += ' ua-ios-' + matches[1];// e.g. ua-ios-7_0_2
      }

      // Add class for Twitter app
      if ( /Twitter/.test(ua) ) {
        classes += ' ua-ios-twitter';
      }

      // Add class for Chrome browser
      if ( /CriOS/.test(ua) ) {
        classes += ' ua-ios-chrome';
      }
    }

    // Detect Android (needed to disable print links on old devices)
    // http://www.ainixon.me/how-to-detect-android-version-using-js/
    if ( /Android/.test(ua) ) {
      var matches = ua.match(/Android\s([0-9\.]*)/);
      classes += matches ? ' ua-aos ua-aos-' + matches[1].replace(/\./g,'_') : ' ua-aos';
    }

    // Detect webOS (needed to disable optimizeLegibility)
    if ( /webOS|hpwOS/.test(ua) ) {
      classes += ' ua-webos';
    }

    // Detect Samsung Internet browser
    if ( /SamsungBrowser/.test(ua) ) {
      classes += ' ua-samsung';
    }

    d.className = classes;
  },

  /**
   * Generates a 32 bit integer from a string
   * Reference - https://stackoverflow.com/a/7616484
   *
   * @param {string}
   * @return {int}
   */
  hashFromString: function(string) {
    var hash = 0, i, chr;
    if (string.length === 0) return hash;
    for (i = 0; i < string.length; i++) {
      chr   = string.charCodeAt(i);
      hash  = ((hash << 5) - hash) + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  },

  chosenSelects: function($container) {
    var $selects = $container ? $('select.form-control', $container) : $('select.form-control');
    $selects.not('[data-no-chosen]').chosen();
  },

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  },

  getScrollY: function() {
    return window.scrollY || window.pageYOffset;
  },

  padLeft: function(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {

  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTables: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;
    
    options.$tables.addClass('table');
    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },  

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '¥{{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
	case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, ',', '.');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, '\'', '.');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  /**
   * Removes '.00' if found at the end of the string
   *
   * @param  {string} value - formatted price (see above)
   * @return {string} value - formatted value
   */
  function stripZeroCents(string) {
    return string.replace(/\.00$/,'');
  }

  return {
    formatMoney: formatMoney,
    stripZeroCents: stripZeroCents
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */
  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
            currentOption.name  = $element.data('name');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');
          currentOption.name  = $element.data('name');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();
      var currentOptions = this._getCurrentOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant,
        currentOptions: currentOptions
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

// slate.CartAPI is a proxy to the Shopify AJAX API calls (ShopifyAPI namespace)
// We need a middle layer so that we can handle logic around product bundles and fix the cart

(function($, slate, undefined){
  
  // ShopifyAPI methods are only accessible inside this file
  var ShopifyAPI = (function(){

    function API() {

      var _cart = null;

       // Wrapper around _cart access - Fetches the cart if this variable isn't set
      this._useCart = function() {  
        var p = $.Deferred();

        if(_cart) {
          p.resolve(_cart)
        }
        else {
          this.getCart().then(function(cart) {
            p.resolve(_cart)   
          })
        }

        return p;
      };

      // Callback for all cart change requests (add, remove, change line item)
      // that fetches a fresh copy of the cart and returns that upon resolving the promise passed in
      this._onChangeRequestDone = function(promise) {
        this.getCart().then(function(response) {
          promise && promise.resolve(response);
        })
      };

      this._onChangeRequestFail = function(promise, msg) {
        promise && promise.reject({
          message: (msg || 'The quantity you entered is not available.')
        })
      };

      this.getCart = function() {
        var promise = $.Deferred();

        $.ajax({
          type: 'get',
          url: '/cart?view=json',
          success: function(data) {
            // Theme editor adds HTML comments to JSON response, strip these
            data = data.replace(/<\/?[^>]+>/gi, '');     
            var cart = JSON.parse(data);
            _cart = cart; // update the local copy we keep on hand
            promise.resolve(cart); // Pass it along as the resolved promise arg
          },
          error: function() {
            promise.reject({
              message: 'Could not retrieve cart items'
            });
          }
        });

        return promise;
      };

     /**
      * AJAX add to cart
      *
      * @param {Object} data - Data object
      * @return {Promise} - Resolve returns JSON cart | Reject returns an error message
      */
      this.add = function(data) {
        var promise = $.Deferred();

        $.post({
          url: '/cart/add.js',
          dataType: 'json',
          data: data
        })
          .done(this._onChangeRequestDone.bind(this, promise))
          .fail(this._onChangeRequestFail.bind(this, promise))

        return promise;
      };

     /**
      * AJAX submit an 'add to cart' form
      *
      * @param {jQuery} $form - jQuery instance of the form
      * @return {Promise} - Resolve returns JSON cart | Reject returns an error message
      */
      this.addItemFromForm = function($form) {
        return this.add($form.serialize());
      };

     /**
      * AJAX change line item
      *
      * @param {Object} data - Data object
      * @return {Promise} - Resolve returns JSON cart | Reject returns an error message
      */
      this.changeLineItem = function(data) {
        var promise = $.Deferred();

        $.post({
          url: '/cart/change.js',
          dataType: 'json',
          data: data
        })
          .done(this._onChangeRequestDone.bind(this, promise))
          .fail(this._onChangeRequestFail.bind(this, promise))

        return promise;
      };

      this._processChangeQueue = function(queue) {
        var promise = $.Deferred();

        if(queue.length == 0) {
          promise.resolve();
          return;
        }

        function makeRequest() {
          var data = queue.shift();

          // We need to use /cart/change.js because that's the only endpoint that allows us to remove items by line item KEY      
          $.ajax({
            type: "POST",
            url: '/cart/change.js',
            dataType: 'json',
            data: data
          })
          .done(function() {
            queue.length ? makeRequest() : promise.resolve();
          })
          .fail(function() {
            promise.reject(); // @TODO - What to do with all the items we added? :-/
          });
        }

        makeRequest(); // Kick off the queue processing

        return promise;
      };

     /**
      * Change multiple cart items
      *
      * @param {Array} array - Array of data objects
      * @param {Object} array[i] - {} object to get passed to /cart/change.js
      * @return {Promise} - Resolve returns JSON cart | Reject returns an error message
      */
      this.changeItems = function(array) {
        var promise = $.Deferred();
        
        this._processChangeQueue(array)
          .done(this._onChangeRequestDone.bind(this, promise))
          .fail(this._onChangeRequestFail.bind(this, promise));

        return promise;
      }
    }

    return new API();
  })();




  // Expose methods
  slate.CartAPI = {
   /**
    * Proxy between receiving the cart from the server and passing it along to whatever needs it
    * Removed any orphan bundle items if necessary
    *
    * @param {object} cart - JSON representation of the cart.  See /templates/cart.json.liquid
    * @return {object} promise - $.Deferred
    */
    _enforceCart(cart) {
      var promise = $.Deferred();
      var data;

      if(!cart) {
        promise.reject();
      }
      else {
        if (cart.items_to_remove && cart.items_to_remove.length) {
           data = $.map(cart.items_to_remove, function(key) {
                          return {
                            id: key,
                            quantity: 0
                          }
                        });

          ShopifyAPI.changeItems(data)
            .then(function(newCart){
              promise.resolve(newCart);
            })
        }
        else {
          promise.resolve(cart);
        }
      }

      return promise;
    },
    
   /**
    * Final step for any CartAPI methods that return the cart from the server
    * Makes sure that nothing is fishy about the cart before passing it on to the final callback
    *
    * @param {object} cart - JSON representation of the cart.  See /templates/cart.json.liquid
    * @param {object} promise - $.Deferred
    * @return {undefined}
    */
    _onRequestDone(cart, promise) {
      var self = this;

      self._enforceCart(cart)
        .then(function(enforcedCart){
          promise.resolve(self.fixCart(enforcedCart));
        });
    },

   /**
    * Modifies the JSON cart for consumption by our handlebars template
    *
    * @param {object} cart - JSON representation of the cart.  See https://help.shopify.com/themes/development/getting-started/using-ajax-api#get-cart
    * @return {object} - fixed up cart
    */
    fixCart(cart) {
      if(cart.fixed && cart.fixed === true) {
        return cart;
      }

      cart.total_price = slate.Currency.formatMoney(cart.total_price, theme.moneyFormat);
      cart.total_price = slate.Currency.stripZeroCents(cart.total_price);

      cart.items.map(function(item) {
        item.image      = slate.Image.getSizedImageUrl(item.image, '200x');
        item.line_price = slate.Currency.formatMoney(item.line_price, theme.moneyFormat);
        item.line_price = slate.Currency.stripZeroCents(item.line_price);

        // Remove "hidden" item properties so they don't get displayed
        $.each(item.properties, function(key, val) {
          if(key.charAt(0) === '_') {
            delete item.properties[key];
          }
        });

        if(item.bundle) {
          item.bundle.item.image = slate.Image.getSizedImageUrl(item.bundle.item.image, '200x');
          if(item.bundle.item.line_price === 0) {
            item.bundle.item.line_price = 'FREE';
          }
          else {
            item.bundle.item.line_price = slate.Currency.formatMoney(item.bundle.item.line_price, theme.moneyFormat);
            item.bundle.item.line_price = slate.Currency.stripZeroCents(item.bundle.item.line_price);
          }
        }

        // We only display the quantity if they have more than 1 of a line item variant
        if(item.quantity > 1) {
          item.multiple_quantity = true
        }

        // Adjust the item's variant options to add "name" and "value" properties
        if(item.product) {
          for (var i = item.variant_options.length - 1; i >= 0; i--) {
            var name  = item.product.options[i];
            var value = item.variant_options[i];

            item.variant_options[i] = {
              name: name,
              value: value
            };

            // Don't show this info if it's the default variant that Shopify creates
            if(value == "Default Title") {
              delete item.variant_options[i];
            }
          }
        }        

        return item;
      });

      cart.fixed = true;

      return cart;
    },

   /**
    * Retrieve a JSON respresentation of the users cart
    *
    * @return {Promise} - JSON cart
    */    
    getCart() {
      var self = this;
      var promise = $.Deferred();

      ShopifyAPI.getCart()
        .done(function(cart){
          self._onRequestDone(cart, promise);
        })
        .fail(function(data){
          promise.reject(data);
        })

      return promise;
    },

   /**
    * Accepts an "add to cart" form element with the required input values for the Shopify API (via $form.serialize())
    * Also accepts a form input with name 'bundle-variant' which, if exists, will add that variant as a child of the
    * product that the form is associated with
    *
    * @return {Promise}
    */   
    addItemFromForm($form) {
      var self = this;
      var promise = $.Deferred();
      var parentVariantID = parseInt($form.find('[name="id"]').val())
      var bundleID = null;
      var bundleVariantID = $form.find('[name="bundle-variant"]').val() && parseInt($form.find('[name="bundle-variant"]').val());
      var addFunction;

      if(bundleVariantID) {
        bundleID = parentVariantID + bundleVariantID; // By doing this instead of generating a random ID, it allows the cart to handle multiple product bundles elegantly

        // Add Both Items at the same time
        var items = [
          {
            quantity: (parseInt($form.find('[name="quantity"]').val()) || 1),
            id: parentVariantID,
            properties: {
              _bundle_id: bundleID,
              _bundle_parent: true
            }
          },
          {
            quantity: 1,
            id: bundleVariantID,
            properties: {
              _bundle_id: bundleID,
              _bundle_child: true
            }
          }
        ];
        
        addFunction = ShopifyAPI.add({ items: items })
      }
      else {
        addFunction = ShopifyAPI.addItemFromForm($form)
      }

      addFunction
        .done(function(cart){
          self._onRequestDone(cart, promise);
        })
        .fail(function(data){
          promise.reject(data);
        })

      return promise;
    },

    changeLineItem(data) {
      var self = this;
      var promise = $.Deferred();

      ShopifyAPI.changeLineItem(data)
        .done(function(cart){
          self._onRequestDone(cart, promise);
        })
        .fail(function(data){
          promise.reject(data);
        })

      return promise;
    },

    removeLineItem(key) {
      return this.changeLineItem({
        id: key,
        quantity: 0
      })
    },

    removeBundle(bundleID) {
      var self = this;
      var promise = $.Deferred();
      var dataArray;

      ShopifyAPI._useCart().
        then(function(_cart) {
          if(_cart.bundles && _cart.bundles[bundleID]) {
            dataArray = $.map(_cart.bundles[bundleID], function(key) {
                              return {
                                id: key,
                                quantity: 0
                              }
                            });

            ShopifyAPI.changeItems(dataArray)
              .done(function(cart){
                self._onRequestDone(cart, promise);
              })
              .fail(function(data){
                promise.reject(data);
              });
          }
          else {
            self._onRequestDone($.extend({}, _cart), promise);
          }
        });

      return promise;
    }
  }
})(jQuery, slate);
/**
 * AJAX Cart scripts
 * ------------------------------------------------------------------------------
 *
 * Requires slate.cartAPI
 * 
 * Usage:
 *  var ajaxCart = new slate.AjaxCart();
 *      ajaxCart.init(options);
 */

(function($, Handlebars, slate, Cookies){

  var CartAPI = slate.CartAPI;

  /*============================================================================
    Ajax Shopify Add To Cart
  ==============================================================================*/
  slate.AjaxCart = (function() {
    
    var $window = $(window);
    var $body = $('body');

    var selectors = {
      container: '[data-ajax-cart-container]',
      body: '[data-ajax-cart-body]',
      footerTotals: '[data-ajax-cart-footer-totals]',
      bodyTemplate: 'script[data-ajax-cart-body-template]',
      footerTotalsTemplate: 'script[data-ajax-cart-footer-totals-template]',
      trigger: '[data-ajax-cart-trigger]',
      close: '[data-ajax-cart-close]',
      addForm: 'form[action^="/cart/add"]',
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      item: '[data-ajax-item]',
      itemRemove: '[data-ajax-cart-item-remove]',
      cartBadge: '[data-cart-badge]',
      cartBadgeCount: '[data-cart-badge-count]',
      empty: '[data-cart-empty]',
      goal: '[data-goal]'
    };

    var classes = {
      bodyCartOpen: 'ajax-cart-open',
      cartOpen: 'is-open',
      cartBadgeHasItems: 'has-items',
      cartIsEmpty: 'is-empty',
      backdrop: 'ajax-cart-backdrop',
      backdropVisible: 'is-visible',
      rowIsBeingRemoved: 'is-being-removed'
    };

   /**
    * AjaxCart constructor
    *
    * Adds an `init` method with access to private variables inside the contructor
    */
    function AjaxCart() {
      this.name = 'ajaxCart'
      this.namespace = '.' + this.name;
      this.events = {
        RENDER:  'render'  + this.namespace,
        DESTROY: 'destroy' + this.namespace,
        SCROLL:  'scroll'  + this.namespace
      };  

      var initialized = false;

      this.$el         = $(selectors.container);
      this.$cartBody   = $(selectors.body, this.$el);
      this.$cartFooterTotals = $(selectors.footerTotals, this.$el);
      this.$goal             = $(selectors.goal, this.$el);

      this.$backdrop   = null;
      this.stateIsOpen = null;
      this.transitionEndEvent = slate.utils.whichTransitionEnd();
      this.rendered = false; // Keep track of whether or not the cart has rendered yet, don't open if it hasn't been

      // Goal messaging vars
      this.goalEnabled = this.$goal.length;
      this.goalAmount = parseFloat(this.$goal.data('goal-amount'));
      this.goalRemainingPre = this.$goal.data('goal-remaining-pre');
      this.goalRemainingPost = this.$goal.data('goal-remaining-post');
      this.goalSuccessMessage = this.$goal.data('goal-success-message');
      this.goalPitch = this.$goal.data('goal-pitch');

      // These elements are *not* scoped to the ajaxCart (they exist in the header)
      this.$badge = $(selectors.cartBadge);
      this.$count = $(selectors.cartBadgeCount);      

     /**
      * Initialize the cart
      *
      * @param {object} options - see `settings` variable above
      */
      this.init = function(options) {
        if(initialized) return;

        var $bodyTemplate = $(selectors.bodyTemplate);
        var $footerTotalsTemplate = $(selectors.footerTotalsTemplate)

        if(!($bodyTemplate.length && $footerTotalsTemplate.length)){
          //console.warn('['+this.name+'] - Handlebars template required to initialize AjaxCart');
          return;
        }

        // Compile this once during initialization
        this.bodyTemplate = Handlebars.compile($bodyTemplate.html());
        this.footerTotalsTemplate = Handlebars.compile($footerTotalsTemplate.html());

        $body.on('submit', selectors.addForm, this.onAddFormSubmit.bind(this)); // the AJAX Part
        $body.on('click', selectors.trigger, this.onTriggerClick.bind(this));
        $body.on('click', selectors.close, this.onCloseClick.bind(this));
        $body.on('click', selectors.itemRemove, this.onItemRemoveClick.bind(this));
        this.$el.on('submit', 'form[action="/cart"]', this.onCartFormSubmit.bind(this));

        // For international users, GlobalE changes text on the page so let's just kill the goal functionality for now
        var globalECookie = Cookies.get('GlobalE_Data');
        var globalEEnabled = !!theme.globalEEnabled;

        if(globalEEnabled && globalECookie !== undefined && JSON.parse(globalECookie).countryISO !== "US") {
          this.goalEnabled = false;
          this.$goal.parent('.ajax-cart__footer-row').remove();
        }        

        // Get the cart data when we initialize the instance
        CartAPI.getCart().then(this.renderCart.bind(this));

        initialized = true;

        return initialized;
      };

      return this;
    }

    AjaxCart.prototype = $.extend({}, AjaxCart.prototype, {     
      onAddFormSubmit: function(e) {
        e.preventDefault();
        
        var self = this;
        var $form = $(e.target);
        var $submitButton = $form.find(selectors.addToCart);
        var $submitButtonText = $submitButton.find(selectors.addToCartText);

        // Update the submit button text and disable the button so the user knows the form is being submitted
        $submitButton.prop('disabled', true);
        $submitButtonText.html(theme.strings.adding);

        CartAPI.addItemFromForm($form)
          .done(function(cart) {
            self.onItemAddSuccess(cart);
          })
          .fail(function(data) {
            self.onItemAddFail(data);
          })
          .always(function() {
            $submitButton.prop('disabled', false);
            $submitButtonText.html(theme.strings.addToCart);
          });
      },

      _getItemRowAttributes: function(el) {
        var $el = $(el);
        var $row = $el.is(selectors.item) ? $el : $el.parents(selectors.item);

        return {
          $row:     $row,
          key:      $row.data('key'),
          bundleID: $row.data('bundle-id')
        };
      },

      addBackdrop: function(callback) {
        var _this = this;
        var cb    = callback || $.noop;

        if(this.stateIsOpen) {
          this.$backdrop = $(document.createElement('div'));

          this.$backdrop.addClass(classes.backdrop)
                        .appendTo($body);

          this.$backdrop.one(this.transitionEndEvent, cb);
          this.$backdrop.one('click', this.close.bind(this))

          // debug this...
          setTimeout(function() {
            _this.$backdrop.addClass(classes.backdropVisible);
          }, 10);
        }
        else {
          cb();
        }
      },

      removeBackdrop: function(callback) {
        var _this = this;
        var cb    = callback || $.noop;

        if(!this.stateIsOpen && this.$backdrop) {
          this.$backdrop.one(this.transitionEndEvent, function(){
            _this.$backdrop && _this.$backdrop.remove()
            _this.$backdrop = null;
            cb();
          });

          setTimeout(function() {
            _this.$backdrop.removeClass(classes.backdropVisible);
          }, 10);
        }
        else {
          cb();
        }
      },      

     /**
      * Callback when adding an item is successful
      *
      * @param {Object} cart - JSON representation of the cart.
      */
      onItemAddSuccess: function(cart){
        this.renderCart(cart);
        this.open();
      },

     /**
      * STUB - Callback when adding an item fails

      * @param {Object} data
      * @param {string} data.message - error message
      */
      onItemAddFail: function(data){
        // console.log('['+this.name+'] - onItemAddFail');
        // console.warn('['+this.name+'] - ' + data.message);
      },

      renderCart: function(cart, slot) {
        $window.trigger(this.events.DESTROY);

        if (slot === 'body') {
          this.$cartBody.empty().append(this.bodyTemplate(cart));
        }
        else if(slot === 'footer') {
          this.$cartFooterTotals.empty().append(this.footerTotalsTemplate(cart));
        }
        else {
          this.$cartBody.empty().append(this.bodyTemplate(cart));
          this.$cartFooterTotals.empty().append(this.footerTotalsTemplate(cart));
        }

        $window.trigger($.Event(this.events.RENDER, { cart : cart }));

        this.$el.toggleClass(classes.cartIsEmpty, (cart.item_count === 0))
        this.updateCartCount(cart);
        this.setGoalMessage(cart);
        this.rendered = true;
      },

     /**
      * Update the cart badge + count here
      *
      * @param {Object} cart - JSON representation of the cart.
      */
      updateCartCount: function(cart) {
        this.$count.html(cart.item_count);
        this.$badge.toggleClass(classes.cartBadgeHasItems, (cart.item_count > 0));
      },

     /**
      * Update the goal message based on the cart amount
      *
      * @param {Object} cart - JSON representation of the cart.
      */
      setGoalMessage: function(cart) {
        if (this.goalEnabled === false || this.$goal.length == 0) return;

        var cartTotal = cart.original_total_price/100;
        var msg;
        var remaining;

        if(cartTotal == 0) {
          msg = this.goalPitch;
        }
        else if(cartTotal > this.goalAmount) {
          msg = this.goalSuccessMessage;
        }
        else {
          remaining = this.goalAmount - cartTotal;
          remaining = remaining * 100; // Shopify works in cents
          remaining = slate.Currency.formatMoney(remaining, theme.moneyFormat); // Format it nicely
          remaining = slate.Currency.stripZeroCents(remaining); // strip cents

          msg = this.goalRemainingPre + ' ' + remaining + ' ' + this.goalRemainingPost;
        }

        this.$goal.html(msg);        
      },

     /**
      * Remove the item from the cart.  Extract this into a separate method if there becomes more ways to delete an item
      *
      * @param {event} e - Click event
      */
      onItemRemoveClick: function(e) {
        e.preventDefault();

        var self = this;
        var attrs = this._getItemRowAttributes(e.target);
        var $row = attrs.$row;
        var removeFunc = attrs.bundleID ? CartAPI.removeBundle(attrs.bundleID) : CartAPI.removeLineItem(attrs.key)

        $row.addClass(classes.rowIsBeingRemoved);

        removeFunc
          .then(
            function(cart){
              $row.slideUp(250, 'easeOutCubic', function() {
                $row.remove();
                self.renderCart(cart, (cart.item_count > 0 ? 'footer' : null)); // Only need to re-render the footer if we still have items in the cart
              });            
            }
          )
      },

     /**
      * Called when someone submits the ajax cart form to go to checkout
      *
      * @param {event} e - Submit Event
      */
      onCartFormSubmit: function(e) {
        e.preventDefault();

        $(e.currentTarget).find('button[type="submit"]').text('Redirecting...')

        // Need to fetch the cart (which calls the cart enforcer) before going to checkout *just* to make sure that everything is good
        CartAPI.getCart()
          .then(function() {
            window.location = '/checkout';
          })

        return false;
      },

      onTriggerClick: function(e) {
        e.preventDefault();
        this.toggleVisibility();
      },

      onCloseClick: function(e) {
        e.preventDefault();
        this.close();
      },

      toggleVisibility: function() {
        return this.stateIsOpen ? this.close() : this.open();
      },

      isOpen: function() {
        return this.stateIsOpen;
      },

      isClosed: function() {
        return !this.stateIsOpen;
      },

      open: function() {
        if(this.stateIsOpen || !this.rendered) return;
        this.stateIsOpen = true;

        $body.addClass(classes.bodyCartOpen);
        this.addBackdrop();
        this.$el.addClass(classes.cartOpen);
      },

      close: function() {
        if(!this.stateIsOpen) return;

        this.stateIsOpen = false;

        this.$el.removeClass(classes.cartOpen);
        this.removeBackdrop(function() {
          $body.removeClass(classes.bodyCartOpen);
        });        
      }
    });

    return AjaxCart;
  })();
})(jQuery, Handlebars, slate, Cookies);


/**
 * Animation Helper Functions / constants
 * -----------------------------------------------------------------------------
 * A collection of functions that help with animations in javascript
 *
 */

slate.animations = (function($) {

  // First add some extra easing equations
  // To add more see the full library - https://github.com/danro/jquery-easing/blob/master/jquery.easing.js
  $.extend( $.easing, {
    // t: current time, b: begInnIng value, c: change In value, d: duration
    easeInQuad: function (x, t, b, c, d) {
      return c*(t/=d)*t + b;
    },
    easeOutQuad: function (x, t, b, c, d) {
      return -c *(t/=d)*(t-2) + b;
    },    
    easeInCubic: function (x, t, b, c, d) {
      return c*(t/=d)*t*t + b;
    },
    easeOutCubic: function (x, t, b, c, d) {
      return c*((t=t/d-1)*t*t + 1) + b;
    },
    easeInOutCubic: function (x, t, b, c, d) {
      if ((t/=d/2) < 1) return c/2*t*t*t + b;
      return c/2*((t-=2)*t*t + 2) + b;
    },
    easeOutQuart: function (x, t, b, c, d) {
      return -c * ((t=t/d-1)*t*t*t - 1) + b;
    },    
    easeInQuint: function (x, t, b, c, d) {
      return c*(t/=d)*t*t*t*t + b;
    },
    easeOutQuint: function (x, t, b, c, d) {
      return c*((t=t/d-1)*t*t*t*t + 1) + b;
    },
    easeInOutQuint: function (x, t, b, c, d) {
      if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
      return c/2*((t-=2)*t*t*t*t + 2) + b;
    }
  });

  // Match those set in variables.scss
  var _transitionTimingDurations = {
    base:     300,
    fast:     150,
    fastest:  50,
    slow:     600,
    none:     0
  };

  var _transitionTimingFunctions = {
    base:      'ease-in-out',
    in:        'ease-out',
    out:       'ease-in',
    inOutUI:   'cubic-bezier(0.42, 0, 0.13, 1.04)'
  };

 /**
  * Get one of the durations stored in the variable defined above
  * If the requested duration doesn't exist, fallback to the base
  *
  * @param {string} key - string matching one of the key names
  * @return {int} - duration in ms
  */
  function getTransitionTimingDuration(key) {
    var k = 'base';
    if(_transitionTimingDurations.hasOwnProperty(key)) {
      k = key;
    }
    return _transitionTimingDurations[k];
  }

 /**
  * Get one of the timing functions stored in the variable defined above
  * If the requested function doesn't exist, fallback to the base
  *
  * @param {string} key - string matching one of the key names
  * @return {string} - valid css timing function
  */
  function getTransitionTimingFunction(key) {
    var k = 'base';
    if(_transitionTimingFunctions.hasOwnProperty(key)) {
      k = key;
    }
    return _transitionTimingFunctions[k];
  };  

  return {
    getTransitionTimingDuration: getTransitionTimingDuration,
    getTransitionTimingFunction: getTransitionTimingFunction
  };

}(jQuery));
/**
 * User Scripts
 * -----------------------------------------------------------------------------
 * Mostly handles cookie setting / removal, logic around user sessions
 *
 * @namespace user
 */

slate.user = (function(Cookies) {

  var cookiePrefix = '_fa_'

 /**
  * User constructor
  */
  function User() {
    this.name = 'user'
    this.namespace = '.' + this.name;

    // Do any initialization here
    // For instance, you could increment a cookie that tracks visits to the site

    return this;
  };

  User.prototype = $.extend({}, User.prototype, {

   /**
    * Library of cookies to use throughout the site.
    * Use the `generateCookie` method below to create your own copies of these.  Don't access these directly.
    */
    _cookies: {
      siteVisit: {
        name: cookiePrefix + 'site_visit',
        value: true
      },
  subscriptionSlideupSeen: { name: 'subscriptionSlideup_seen', value: true },
      subscriptionSlideupSeen: {
        name: 'subscriptionSlideup_seen',
        value: true
      },
      subscriptionModalSeen: {
        name: 'subscriptionModal_seen',
        value: true
      },
      emailCollected: {
        name: 'emailCollected',
        value: true
      }      
    },

   /**
    * Creates and returns a copy of one of the cookies available above
    *
    * @param {String} key
    * @return {Object | undefined}
    */
    generateCookie: function(key) {
      var c;
      if(this._cookies.hasOwnProperty(key)) {
        c = $.extend(true, {}, this._cookies[key]);
        c.name = cookiePrefix + c.name;
      }
      else {
        //console.warn('['+this.name+'] - Cannot create cookie.  Key "' + key + '" not found.' );
      }
      return c;
    },    
    
   /**
    * Sets a browser cookie
    *
    * @param {Object} cookie
    * @param {String} cookie.name
    * @param {String} cookie.value
    * @param {Number} cookie.expiration - Time to expire in days, expires after session if left blank
    */
    setCookie: function(cookie) {
      if(this.hasCookie(cookie.name) && this.getCookieValue(cookie.name) != cookie.value){
        this.removeCookie(cookie.name);
      }

      var opts = cookie.hasOwnProperty('expiration') ? { expires : cookie.expiration } : {};
      Cookies.set( cookie.name, cookie.value, opts );

      return this;
    },

   /**
    * Checks for the presence of a browser cookie by name (doesn't check for value equality)
    *
    * @param {String} cookieName
    * @return {Boolean}
    */
    hasCookie: function(cookieName) {
      return typeof Cookies.get( cookieName ) !== "undefined";
    },

   /**
    * Returns value of browser cookie by name
    *
    * @param {String} cookieName
    * @return {String | Undefined}
    */
    getCookieValue: function(cookieName) {
      return this.hasCookie( cookieName ) ? Cookies.get( cookieName ) : undefined;
    },

   /**
    * Removes a cookie by name
    *
    * @param {String} cookieName
    * @return {Self}
    */
    removeCookie: function(cookieName) {
      Cookies.remove( cookieName )
      return this;
    }
  });

  return new User();

}(Cookies));
/**
 * Breakpoint Helper Functions / constants
 * -----------------------------------------------------------------------------
 * A collection of functions that help with dealing with site breakpoints in JS
 * All breakpoint properties should be defined here
 *
 */

slate.breakpoints = (function($) {

  var $window = $(window);
  var cachedWindowWidth = $window.width(); 

  // Match those set in variables.scss
  var _breakpointMinWidths = {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1480
  };

  var events = {
    BREAKPOINT_CHANGE: 'breakpointChange',
  };


 /**
  * Get one of the widths stored in the variable defined above
  *
  * @param {string} key - string matching one of the key names
  * @return {int} - pixel width
  */
  function getBreakpointMinWidth(key) {
    if(!key) return;

    if(_breakpointMinWidths.hasOwnProperty(key)) {
      return _breakpointMinWidths[key];
    }
  }

 /**
  * Gets the key for one of the breakpoint widths, whichever is closest but smaller to the passed in width
  * So if we pass in a width between 'sm' and 'md', this will return 'sm'
  *
  * @param {int} w - width
  * @return {undefined|string} foundKey
  */
  function getBreakpointMinWidthKeyForWidth(w) {
    var w = w != undefined ? w : $window.width();
    var previousKey;
    var foundKey;

    $.each(_breakpointMinWidths, function(k, bpMinWidth) {
      if(w > bpMinWidth) {
        previousKey = k;
      }
      else {
        foundKey = previousKey;
      }
    });

    return foundKey;
  }

 /**
  * Triggers a window event when a breakpoint is crossed, passing the new minimum breakpoint width key as an event parameter
  *
  */
  function onResize() {
    var newWindowWidth = $window.width();

    $.each(_breakpointMinWidths, function(k, bpMinWidth) {
      if( (newWindowWidth >= bpMinWidth && cachedWindowWidth < bpMinWidth) || (cachedWindowWidth >= bpMinWidth && newWindowWidth < bpMinWidth) ) {
        
        var bpMinWidthKey = getBreakpointMinWidthKeyForWidth(newWindowWidth);
        var e = $.Event(events.BREAKPOINT_CHANGE, { bpMinWidthKey: bpMinWidthKey });
        $window.trigger(e);
        return false;

      }
    });

    cachedWindowWidth = $window.width();
  }

  $window.on('resize', $.throttle(20, onResize) );

  return {
    getBreakpointMinWidth: getBreakpointMinWidth
  };

}(jQuery));
/**
 * Product Card Scripts
 * -----------------------------------------------------------------------------
 * Handles any events associated with the product card html (see snippets/product-card.liquid)
 */

slate.productCard = (function($, Modernizr, Swiper) {
  var selectors = {
    el: '[data-product-card]',
    thumb: '[data-thumb]',
    slideshow: '[data-slideshow]',
    slide: '.swiper-slide',
    slideDuplicateImages: '.swiper-slide-duplicate img',
    titleLink: '[data-title-link]'
  };

  var classes = {
    slideshowDisabled: 'is-disabled'
  }

  function ProductCard(el) {
    this.$el = $(el);
    this.$slideshow = $(selectors.slideshow, this.$el);
    this.$slides    = $(selectors.slide, this.$el);
    this.$thumbs    = $(selectors.thumb, this.$el);
    this.$titleLink = $(selectors.titleLink, this.$el);

    this.slideCount   = this.$slides.length; // Swiper can't give you the total count without duplicates..
    this.imgLoadCount = 0

    var touch  = !!Modernizr.touchevents;
    var effect = touch ? 'slide' : 'fade';
    var speed  = touch ? 400 : 0;
    var loop   = this.slideCount > 1 // No need to loop for one image

    this.swiper = new Swiper(this.$slideshow.get(0), {
      init: false,
      loop: loop,
      effect: effect,
      speed: speed,
      simulateTouch: false,
      on: {
        slideChangeTransitionEnd: this.onSlideChangeTransitionEnd.bind(this)
      }
    });

    if (this.slideCount === 1) {
      this.$slideshow.addClass(classes.slideshowDisabled);
    }

    this.swiper.init();

    this.$slideshow.on('lazyloaded', this.onSlideshowLazyLoaded.bind(this));
    this.$thumbs.on('click', this.onThumbClick.bind(this));
	
	//console.log("ProductCard"+el);
	 
  }

  ProductCard.prototype = $.extend({}, ProductCard.prototype, {
    onSlideshowLazyLoaded: function() {
      this.imgLoadCount++;

      // Lazy load the duplicates, these don't get registered with lazySizes for some reason
      if (this.imgLoadCount === this.slideCount) {
        this.$slideshow.find(selectors.slideDuplicateImages).each(function(i, img) {
          lazySizes && lazySizes.loader.unveil(img)
        });
        
        this.$slideshow.off('lazyloaded');
      }
    },
    onSlideChangeTransitionEnd: function() {
      var slideHref = $(this.swiper.slides[this.swiper.realIndex+1]).find('a').first().attr('href');

      slideHref && this.$titleLink.attr('href', slideHref);
    },
    onThumbClick: function(e) {
      var thumbIndex    = $(e.currentTarget).index();
      var currentIndex  = this.swiper.realIndex;
      var maxSlideIndex = this.slideCount - 1;

      if (thumbIndex === currentIndex) return;
    
      // First slide going to last slide
      if (currentIndex === 0 && thumbIndex === maxSlideIndex && this.slideCount > 2) {
        this.swiper.slidePrev()
      }
      // Last slide going to first slide
      else if (currentIndex === maxSlideIndex && thumbIndex === 0 && this.slideCount > 2) {
        this.swiper.slideNext()
      }
      else {
        this.swiper.slideToLoop(thumbIndex);
      }
    },
    onUnveil: function() {
      this.$el.find('img').each(function(i, img) {
        var $img = $(img);
        var srcset = $(img)
      })
      this.$el.addClass(classes.isUnveiled);
    }
  });

  $(document).ready(function() {
    var productCards = $(selectors.el).map(function(i, el) {
      var instance = new ProductCard(el);
      // $(el).data('product-card', instance);
      return instance
    });
  });
}(jQuery, Modernizr, Swiper));
slate.ProductOption = (function($, Modernizr, slate) {
  var selectors = {
    singleOptionSelector: '[data-single-option-selector]',
    optionValueUI: '[data-option-value-ui]'
  };

  var classes = {
    optionValueActive: 'is-active',
  };

  /**
   * ProductOption constructor
   *
   * @param { Object } product - Product instance
   * @param { jQuery } $el - Main element
   */
  function ProductOption(product, el) {
    this.product = product;
    this.$el = $(el);
    this.position = this.$el.data('position');
    this.name = this.$el.data('name');
    this.nameHandle = this.$el.data('name-handle');
    this.positionLabel = 'option' + this.position;
    this.$singleOptionSelector = $(selectors.singleOptionSelector, this.$el);
    this.$optionValueUIs = $(selectors.optionValueUI, this.$el);
    this.$valueOptions = this.$singleOptionSelector.find('option');

    this.$optionValueUIs.on('click', this.onOptionValueUIClick.bind(this));
  }

  ProductOption.prototype = $.extend({}, ProductOption.prototype, {
    _getValueOptionElForVal(value) {
      return this.$valueOptions.filter(function(i, el) {
        return $(el).val() === value
      }).first();
    },
    _getValueUIForVal(value) {
      return this.$optionValueUIs.filter('[data-option-value="'+ value +'"]').first();
    },
    updateOptionValueAvailability: function(value, available, notify) {
      var $el = this._getValueOptionElForVal(value); // <option>
      var $valueUI = this._getValueUIForVal(value); // .swatch, etc..
      var showAsAvailable = available || this.nameHandle === 'color'; // Colors are always available?
      var disabledProp    = showAsAvailable || notify ? null : 'disabled'; // If we can show as available or we can notify for back in stock, allow selection..
      var text = value;

      if (showAsAvailable === false) {
        text += ' - ' + (notify ? 'NOTIFY ME' : 'SOLD OUT') // @TODO - This will need to be translated
      }

      $el
        .prop('disabled', disabledProp)
        .text(text);

      $valueUI.toggleClass('is-disabled', !available);
    },
    updateSelectedStateForValue: function(selectedValue) {
      var $valueUI = this._getValueUIForVal(selectedValue);

      this.$optionValueUIs.removeClass(classes.optionValueActive);
      $valueUI.addClass(classes.optionValueActive);
    },
    // Used to "normalize" the product option after a variant change occurs
    normalize: function() {
      this.$singleOptionSelector.trigger('chosen:updated');
      this.removeErrorState();
    },
    needsSelection: function() {
      var selectVal = this.$singleOptionSelector.val()
      
      return selectVal === null || selectVal.length === 0;
    },
    applyErrorState: function() {
      this.$singleOptionSelector.parents('.form-group').addClass('has-error');
    },
    removeErrorState: function() {
      this.$singleOptionSelector.parents('.form-group').removeClass('has-error');
    },
    onOptionValueUIClick: function(e) {
      var value = $(e.currentTarget).data('option-value');

      if (this.$singleOptionSelector.val() === value) {
        return;
      }

      this.$singleOptionSelector
        .val(value)
        .trigger('change');
    }
  });

  return ProductOption;
})(jQuery, Modernizr, slate);

slate.ProductDetailGallery = (function($, Modernizr, slate, Swiper) {
  var selectors = {
    slideshow: '[data-product-gallery-slideshow]',
    slide: '.swiper-slide',
    slideInner: '.product-gallery__slideshow-slide-inner',
    prev: '[data-prev]', 
    next: '[data-next]',
    // These are external to the actual swiper container
    externalPrev: '[data-ext-prev]',
    externalNext: '[data-ext-next]',
	pagination: '[data-product-gallery-slideshow-pagination]',
    initialSlide: '[data-initial-slide]'
  };

  var classes = {
    active: 'is-active',
    zoomReady: 'is-zoomable',
    zoomedIn: 'is-zoomed',
    slideshowDisabled: 'is-disabled'
  };  

  /**
   * ProductDetailFormGallery constructor
   *
   * @param { jQuery } $el - Main element
   */
  function ProductDetailGallery(el) {
    this.$el = $(el);
    this.$slideshow     = $(selectors.slideshow, this.$el);
    this.$slides        = $(selectors.slide, this.$el);
    this.$prev          = $(selectors.prev, this.$el);
    this.$next          = $(selectors.next, this.$el);
    this.$externalPrev  = $(selectors.externalPrev, this.$el);
    this.$externalNext  = $(selectors.externalNext, this.$el);
    this.$pagination    = $(selectors.pagination, this.$el);
    this.$zoomTarget    = $(null);

    this.slideCount = this.$slides.length; // Swiper can't give you the total count without duplicates..
    this.color = this.$el.data('color');
    this.active = this.$el.hasClass(classes.active);
    this.initialInteractionTimeout = null;
    this.mobileSettings = window.innerWidth < slate.breakpoints.getBreakpointMinWidth('md');

    var touch  = !!Modernizr.touchevents;    
    var effect = touch && this.mobileSettings ? 'slide' : 'fade';
    var speed  = effect === 'slide' ? 600 : 250;
    var loop = this.slideCount > 1

    // We only use this selector when the PDP has a single gallery
    // If we have color galleries we don't need it
    var initialIndex = this.$slideshow.find(selectors.initialSlide).first().index();

    this.swiper = new Swiper(this.$slideshow.get(0), {
      init: false,
      loop: loop,
      effect: effect,
      speed: speed,
      simulateTouch: false,   
      initialSlide: (initialIndex > -1 ? initialIndex : 0), 
      navigation: {
        prevEl: this.$prev.get(0),
        nextEl: this.$next.get(0)
      },
      pagination: {
	  	el: this.$pagination.get(0),
	  	clickable:true
	  },
	  /*pagination: {
        el: this.$pagination.get(0),
        type: 'custom',
        renderCustom: function(swiper, current, total) {
          return [slate.utils.padLeft(current, 2, '0'), slate.utils.padLeft(total, 2, '0')].join('-');
        }
      },*/
      on: {
        init: this.onSwiperInit.bind(this),
        slideChangeTransitionStart: this.initHoverZoom.bind(this),
        touchStart: this.onSwiperTouchStart.bind(this),
        touchMove: this.onSwiperTouchMove.bind(this)
      }
    });

    this.swiper.init();

    if (this.slideCount === 1) {
      this.$slideshow.addClass(classes.slideshowDisabled);
    }

    this.$externalPrev.on('click', function() { this.swiper.slidePrev(); }.bind(this));
    this.$externalNext.on('click', function() { this.swiper.slideNext(); }.bind(this));
  }

  ProductDetailGallery.prototype = $.extend({}, ProductDetailGallery.prototype, {
    initHoverZoom: function() {
      var self = this;

      this.destroyHoverZoom();

      // Don't use activeIndex / realIndex here      
      this.$zoomTarget = this.$slideshow.find('.swiper-slide-active').find(selectors.slideInner);

      var $link = this.$zoomTarget.find('a');

      // Prevents us from following the link while the zoom image loads
      $link.on('click', function(e) {
        e.preventDefault();
        return false;
      });        

      var opts = {
        url: $link.attr('href'),
        on: 'click',
        touch: false,
        escToClose: true,
        zoomMagnify: 0.8,
        zoomDuration: 300,
        callback: function() {
          self.$zoomTarget.addClass(classes.zoomReady);
        },
        onZoomIn: function() {
          self.$zoomTarget.addClass(classes.zoomedIn);
          self.$el.addClass(classes.zoomedIn);
        },
        onZoomOut: function() {
          self.$zoomTarget.removeClass(classes.zoomedIn);
          self.$el.removeClass(classes.zoomedIn);
        }
      };

      this.$zoomTarget.zoom(opts);
    },
    destroyHoverZoom: function() {
      this.$zoomTarget.trigger('zoom.destroy');
    },
    startInteractionTimeout: function() {
      this.initialInteractionTimeout = setTimeout(this.swiper.slideNext.bind(this.swiper), 6000);
    },
    clearInteractionTimeout: function() {
      clearTimeout(this.initialInteractionTimeout);
    },
    activate: function() {
      if (this.active) return;

      this.$el.addClass(classes.active);
      this.swiper.update();
      this.initHoverZoom();
      this.active = true;
    },
    deactivate: function() {
      this.$el.removeClass(classes.active);
      this.destroyHoverZoom();
      this.clearInteractionTimeout();
      this.active = false;
    },
    goToByImageId: function(id) {
      if (!id) return;

      var slideIndex = parseInt(this.$slideshow.find('[data-image="'+ id +'"]').first().data('swiper-slide-index'));
      
      if (!isNaN(slideIndex) && slideIndex > -1) {
        this.swiper.slideToLoop(slideIndex)
      }
    },
    onSwiperInit: function() {
      this.initHoverZoom();

      if (this.mobileSettings && this.active) {
        this.initialInteractionTimeout = setTimeout(this.swiper.slideNext.bind(this.swiper), 6000);
      }
    },
    onSwiperTouchMove: function() {
      this.clearInteractionTimeout();
    },
    onSwiperTouchStart: function() {
      this.clearInteractionTimeout();
    }
  });

  return ProductDetailGallery;
})(jQuery, Modernizr, slate, Swiper);

/**
 * Product Detail Form Script
 * ------------------------------------------------------------------------------
 *
 * Handles all functionality related to contents of snippets/product-detail-form.liquid
 * Core functionality includes:
 *  - Variant selecting + callbacks
 *  - Variant galleries + slideshow initializing
 *
 * Requires:
 *  - jQuery
 *  - Modernizr (for Modernizr.touchevents)
 *  - Slate (for slate.Currency, slate.models.AudioDescription, slate.Variants, slate.utils...)
 */

// Requires slate for slate.Currency


slate.ProductDetailForm = (function($, Modernizr, slate) {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productGallery: '[data-product-gallery]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productOption: '[data-product-option]',
    singleOptionSelector: '[data-single-option-selector]',
    productColor: '[data-product-color]',
    backInStockBtn: '[data-back-in-stock]',
    unavailableMessage: '[data-unavailable-message]',
    addForm: 'form[action^="/cart/add"]',
    shopifyPaymentButton: '.shopify-payment-button',
    audioDescription: '[data-product-audio-description]',
    bundleVariantSelect: '[data-product-bundle-variant]'
  };

  var classes = {
    isReady: 'is-ready',
    hide: 'hide',
    shopifyPaymentButtonDisabled: 'is-disabled'
  };

  var $window   = $(window);
  var $viewport = $('html, body');

  /**
   * ProductDetailForm constructor
   *
   * @param { Object } config
   * @param { jQuery } config.$el - Main element, see snippets/product-detail-form.liquid
   * @param { jQuery } config.$container - Container to listen to scope events / element to listen to events on.  Defaults to config.$el
   */
  function ProductDetailForm(config) {
	/*console.log("ProductDetailForm",config);*/
    this.settings = {};
    this.name = 'productDetailForm';
    this.namespace = '.'+this.name;

    this.events = {
      RESIZE: 'resize' + this.namespace,
      CLICK:  'click'  + this.namespace,
      READY:  'ready'  + this.namespace
    };

    this.mobileBreakpoint = slate.breakpoints.getBreakpointMinWidth('md') || 992;
    
    var initialized = false;

    this.initialize = function() {
      if(initialized) {
        return;
      }

      var self = this;

      this.settings = $.extend({}, config);
      this.$el = this.settings.$el;
      this.$container = this.settings.$container;

      if (!this.settings.$el || this.settings.$el == undefined) {
        //console.warn('['+this.name+'] - $el required to initialize');
        return;
      }

      if (!this.$container || this.$container == undefined) {
        this.$container = this.$el;
      }

      this.$shopifyPaymentButton  = $(selectors.shopifyPaymentButton, this.$container);
      this.$bundleVariantSelect   = $(selectors.bundleVariantSelect,  this.$container);
      this.$productColor          = $(selectors.productColor, this.$container);
      this.$productPrice          = $(selectors.productPrice, this.$container);
      this.$priceWrapper          = $(selectors.priceWrapper, this.$container);
      this.$comparePrice          = $(selectors.comparePrice, this.$container);
      this.$comparePriceEls       = this.$comparePrice.add($(selectors.comparePriceText, this.$container));
      this.$addToCartBtn          = $(selectors.addToCart, this.$container);
      this.$addToCartBtnText      = $(selectors.addToCartText, this.$container);
      this.$backInStockBtn        = $(selectors.backInStockBtn, this.$container);
      this.$unavailableMessage    = $(selectors.unavailableMessage, this.$container);
	  
      this.availableText   = this.$addToCartBtnText.data('available-text')   || /*theme.strings.addToCart ||*/ 'Add To Cart';
      this.unavailableText = this.$addToCartBtnText.data('unavailable-text') || /*theme.strings.soldOut   ||*/ 'Sold Out';
      this.backInStockEnabled = this.$el.data('back-in-stock-enabled') || false;

      this.product = JSON.parse($(selectors.productJson, this.$container).html());
      this.availableVariants = $.map(this.product.variants, function(variant) {
        if (variant.available) {
          return variant;
        }
      })

      var variantOptions = {
        $container: this.$container,
        enableHistoryState: true,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.product
      };

      this.variants = new slate.Variants(variantOptions);
      this.audioDescription = new slate.models.AudioDescription($(selectors.audioDescription, this.$container));
      this.galleries = $.map($(selectors.productGallery, this.$container), function(el, i) { return new slate.ProductDetailGallery(el); });
      this.productOptions = $.map($(selectors.productOption, this.$container), function(el, i) { return new slate.ProductOption(self.product, el); });

      this.$container.on('variantChange' + this.namespace, this.onVariantChange.bind(this));  // See slate.Variants
      this.$container.on('submit', selectors.addForm, this.onAddFormSubmit.bind(this));
      this.$bundleVariantSelect.on('change', this.updatePaymentButtonForBundle.bind(this));

      this.updateOptionValues(this.variants._getCurrentOptions());

      if(this._needsUserSelection(false)) {
        this.$shopifyPaymentButton.addClass(classes.shopifyPaymentButtonDisabled);
      }

      this.updatePaymentButtonForBundle(); // Check the default

      var e = $.Event(this.events.READY);

      this.$el
        .addClass(classes.isReady)
        .trigger(e);

      initialized = true;
    };

    return this;
  };

  ProductDetailForm.prototype = $.extend({}, ProductDetailForm.prototype, {
    /**
     * Checks if any of the option selectors have missing values
     * Should only affect "size" but could theoretically affect any dropdown where we wanted to require user input
     *
     * @param {Bool} applyError - whether or not to add an error class to the select tag, defaults to true
     */
    _needsUserSelection: function(applyError) {
      var needsSelections = false;
          applyError = slate.utils.defaultTo(applyError, true);

      this.productOptions.forEach(function(pO) {
        if (pO.needsSelection()) {
          needsSelections = true;
          applyError && pO.applyErrorState();
        }
      });

      return needsSelections;
    },

    _formatPrice: function(amount) {
      return slate.Currency.stripZeroCents(slate.Currency.formatMoney(amount, theme.moneyFormat))
    },

    onVariantChange: function(evt) {
      var variant        = evt.variant;
      var currentOptions = evt.currentOptions;

      this.updateProductPrices(variant);
      this.updateAddToCartState(variant);
      this.updateProductColor(currentOptions);
      this.updateOptionValues(currentOptions);
      this.updateGalleries(variant, currentOptions);
      this.updatePaymentButtonForBundle();

      this.productOptions.forEach(function(pO) {
        pO.normalize();
      });
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {Object} variant - Shopify variant object
     */
    updateAddToCartState: function(variant) {
      if (variant) {
        this.$priceWrapper.removeClass(classes.hide);

        if (variant.available) {
          this.$addToCartBtn.prop('disabled', false);
          this.$addToCartBtnText.html(this.availableText);
          this.$shopifyPaymentButton.removeClass(classes.shopifyPaymentButtonDisabled);
        }
        else {
          this.$addToCartBtn.prop('disabled', true);
          this.$addToCartBtnText.html(this.unavailableText);
          this.$shopifyPaymentButton.addClass(classes.shopifyPaymentButtonDisabled);
        }
      }
      // No variant found
      else {
        // Because the user selected the default "Select { option_name }"
        if(this._needsUserSelection()) {
          this.$addToCartBtn.prop('disabled', false);
          this.$addToCartBtnText.html(this.availableText);
          this.$shopifyPaymentButton.addClass(classes.shopifyPaymentButtonDisabled);
          this.$priceWrapper.removeClass(classes.hide);
        }
        // Or there *actually* isn't a variant for the combination of options
        else {
          this.$addToCartBtn.prop('disabled', true);
          this.$addToCartBtnText.html(this.unavailableText);
          this.$shopifyPaymentButton.addClass(classes.shopifyPaymentButtonDisabled);
          // this.$priceWrapper.addClass(classes.hide);
        }
      }

      // If we have the back in stock button (and it's enabled for the product), things get a little more complicated
      // Klaviyo onsite.js script is super heavy handed and wants to show the button at all times (it will inject one if we dont)
      // we have to take matters into our own hands !!!!important
      if(this.$backInStockBtn.length && this.backInStockEnabled) {
        if(variant && !variant.available) {
          this.$unavailableMessage.show();
          this.$addToCartBtn.hide();
          this.$backInStockBtn
            .addClass('d-ib-important')
            .removeClass('d-none-important');
        }
        else {
          this.$unavailableMessage.hide();
          this.$addToCartBtn.show();
          this.$backInStockBtn
            .addClass('d-none-important')
            .removeClass('d-ib-important');
        }
      }
      else {
        this.$unavailableMessage.hide();
        this.$addToCartBtn.show();
      }
    }, 

    /**
     * Updates the DOM with specified prices
     *
     * @param {Object} variant - Shopify variant object
     */
    updateProductPrices: function(variant) {
      if(variant) {
        this.$productPrice.html(this._formatPrice(variant.price));

        if (variant.compare_at_price > variant.price) {
          this.$comparePrice.html(this._formatPrice(variant.compare_at_price));
          this.$comparePriceEls.removeClass(classes.hide);
        } else {
          this.$comparePrice.html('');
          this.$comparePriceEls.addClass(classes.hide);
        }
      }
    },

    /**
     * Updates the DOM with the currently selected color (if there is one)
     *
     * @param {Array} currentOptions - Array of options
     * @param {Object} [option]
     * @param {String} option.name  - i.e. "Color"
     * @param {String} option.value - i.e. "Gun Metal"
     */
    updateProductColor: function(currentOptions) {
      var currentColorOption = currentOptions.find(function(opt) { return (opt.name && opt.name.toLowerCase()) === 'color' }) || {};
      this.$productColor.text(currentColorOption.value);
    },

    /**
     * Updates the DOM state of the elements matching the variantOption Value selector based on the currently selected variant
     *
     * @param {Array} currentOptions - Array of options
     * @param {Object} [option]
     * @param {String} option.name  - i.e. "Color"
     * @param {String} option.value - i.e. "Gun Metal"
     */
    updateOptionValues: function(currentOptions) {
      var self = this;

      // Update selected state based on the currently selected options
      currentOptions.forEach(function(currentOption, i) {
        var productOption = self.productOptions.find(function(pO) {
          return pO.name === currentOption.name
        });

        productOption && productOption.updateSelectedStateForValue(currentOption.value);
      });

      // Recursive function to check option values for variant availability
      // Goes deeper until we run out of product options
      function checkOption(optionIndex, availableVariantsArray) {
        var position = optionIndex + 1
        var positionName = 'option' + position;
        var optionWithValues = self.product.options_with_values[optionIndex];
        var optionName = optionWithValues.name

        var productOption = self.productOptions.find(function(pO) {
          return pO.name === optionName
        });

        optionWithValues.values.forEach(function(value) {
          var availableVariantsForValue = availableVariantsArray.filter(function(variant) {
            return variant[positionName] === value && variant.available;
          });

          var available = availableVariantsForValue.length > 0
          var notify    = self.backInStockEnabled

          productOption && productOption.updateOptionValueAvailability(value, available, notify);

          // If our loop is on a currently selected option and we can go deeper...
          if (currentOptions[optionIndex] && currentOptions[optionIndex].value === value && self.product.options_with_values[optionIndex + 1]) {
            checkOption(optionIndex + 1, availableVariantsForValue)
          }
        });
      }

      checkOption(0, self.availableVariants)
    },

    /**
     * Look for a gallery matching one of the selected variant's options and switch to that gallery
     * If a matching gallery doesn't exist, look for the variant's featured image in the main gallery and switch to that
     *
     * @param {Object} variant - Shopify variant object
     * @param {Array} currentOptions - Array of options
     * @param {Object} [option]
     * @param {String} option.name  - i.e. "Color"
     * @param {String} option.value - i.e. "Gun Metal"     
     */
    updateGalleries: function(variant, currentOptions) {
      var currentColorOption = currentOptions.find(function(opt) { return (opt.name && opt.name.toLowerCase()) === 'color' }) || {};
      var selectedColor      = currentColorOption.value;
      var isMobile           = window.innerWidth < this.mobileBreakpoint;

      if (this.galleries.length > 1) {
        if (selectedColor !== null) {
          var activeGallery = this.galleries.find(function(gallery) { return gallery.active; });
          var selectedColorGallery = this.galleries.find(function(gallery) { return gallery.color === selectedColor });

          if (activeGallery !== selectedColorGallery) {
            activeGallery.$el.stop().fadeTo(120, 0, 'easeOutQuad', function() {
              activeGallery.deactivate();
              selectedColorGallery.$el.css('opacity', 0);
              selectedColorGallery.activate();
              setTimeout(function() {
                selectedColorGallery.$el.stop().fadeTo(350, 1, 'easeInQuad');              
              }, 20);
            });

            if (isMobile) {
              var scrollPosition = slate.utils.getScrollY();
              var scrollTop = this.$el.offset().top - 56; // 56 => mobile header height
              var distanceToScroll = scrollPosition - scrollTop;
              var scrolledPastGalleryMidpoint = distanceToScroll > activeGallery.$el.outerHeight()/2
    
              if (scrolledPastGalleryMidpoint) {
                $viewport.animate({ scrollTop: scrollTop }, {
                  duration: 400,
                  easing: 'easeOutQuart'
                });
              }
            }          
          }
        }
      }
      else if (variant) {
        this.galleries[0].goToByImageId(variant.featured_image.id)
      }
    },

    updatePaymentButtonForBundle: function() {
      if (this.$bundleVariantSelect.length) {
        // Hide if there's a variant selected, accelerated checkout won't work
        this.$shopifyPaymentButton.toggleClass(classes.hide, !!this.$bundleVariantSelect.val());  
      }
    },

    onAddFormSubmit: function(e) {
      if(this._needsUserSelection()) return false;
    }
  });

  return ProductDetailForm;
})(jQuery, Modernizr, slate);
/**
 * AJAX Klaviyo Library
 * -----------------------------------------------------------------------------
 * Handles AJAX form submission and callback event
 *
 * Usage:
 *
 *   var $form = $('form');
 *   var listId = $form.data('list-id');
 *   var source = $form.data('source');
 *
 *   var options = {
 *     listId: listId,
 *     source: source,
 *     onSubscribeSuccess: function() { .. },
 *     onSubmitFail: function(){ .. }
 *   };
 *
 *   var ajaxKlaviyoForm = new slate.AjaxKlaviyoForm($form, options);
 *
 * @namespace ajaxKlaviyoForm
 */


slate.AjaxKlaviyoForm = (function($) {

 /**
  * AJAX Klaviyo Form Constructor
  *
  * @param {HTMLElement | jQuery} form - Form element
  * @param {Object} options
  * @param {String} options.listId - Klaviyo List ID
  * @param {String} options.source - Klaviyo custom $source property
  * @param {Function} options.onInit
  * @param {Function} options.onBeforeSend - Prevent AJAX submission by returning false here
  * @param {Function} options.onSubmitFail  
  * @param {Function} options.onSubscribeSuccess
  * @param {Function} options.onSubscribeFail
  * @return {self}
  */
  function AjaxKlaviyoForm(form, options) {

    this.name = 'ajaxKlaviyoForm'
    this.namespace = '.' + this.name;
    this.events = {
      SUBMIT: 'submit' + this.namespace
    };

    var _this = this;
    var defaults = {
      source: "Shopify Form",
      onInit: $.noop,
      onBeforeSend: $.noop,
      onSubmitFail: $.noop,
      onSubscribeSuccess: $.noop,
      onSubscribeFail: $.noop
    };

    if (form.length === 0) {
      return false;
    }

    this.$form    = form instanceof jQuery ? form : $(form);
    this.$input   = this.$form.find('input[type="email"]');
    this.$submit  = this.$form.find('[type="submit"]');
    this.settings = $.extend({}, defaults, options);
    this.isSubmitting = false;

    if(!this.settings.listId) {
      //console.warn('['+this.name+'] - Valid Klaviyo List ID required to initialize');
      return;
    }

    this.$form.on(this.events.SUBMIT, this.onFormSubmit.bind(_this));

    this.settings.onInit();
  };

  AjaxKlaviyoForm.prototype = $.extend({}, AjaxKlaviyoForm.prototype, {
    onBeforeSend: function() {
      if(this.settings.onBeforeSend() == false) {
        return false;
      }

      if (this.$input.val() && this.$input.val().length) {
        this.$submit.prop('disabled', true);
        this.isSubmitting = true;

        return true;
      }
      
      this.$input.parents('.form-group').addClass('alert-info');

      return false;
    },
    onSubmitDone: function(response) {
      this.$submit.prop('disabled', false);

      if(response.success) {
        this.settings.onSubscribeSuccess();
      }
      else {
        this.settings.onSubscribeFail();
      }
    },
    onSubmitFail: function(errors) {
      this.$submit.prop('disabled', false);

      if(errors instanceof Array && errors.length) {
        for (var i = errors.length - 1; i >= 0; i--) {
          //console.warn('['+this.name+'] - onSubmitFail error: "' + errors[i] + '"');
        }
      }
      this.settings.onSubmitFail(errors);
    },
    onFormSubmit: function(e) {
      e.preventDefault();
      var _this = this;

      $.ajax({
          async: true,
          crossDomain: true,
          url: '//manage.kmail-lists.com/ajax/subscriptions/subscribe',
          method: "POST",
          headers: {
              "content-type": "application/x-www-form-urlencoded",
              "cache-control": "no-cache"
          },
          data: {
              "g": this.settings.listId,
              "$fields": "$source",
              "email": this.$input.val(),
              "$source": this.settings.source
          },
          beforeSend: _this.onBeforeSend.bind(_this)
        })
        .done(function(response) {
          _this.onSubmitDone(response);
        })
        .fail(function(jqXHR, textStatus) {        
          var errors = [];

          if (jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.hasOwnProperty('errors')) {
            errors = jqXHR.responseJSON.errors;
          }

          _this.onSubmitFail(errors);
        })
        .always(function() {
          _this.isSubmitting = false;
        });

      return false;
    }
  });

  return AjaxKlaviyoForm;
})(jQuery)

/**
 * Drawer
 * ------------------------------------------------------------------------------
 *
 * Requires:
 *  - Modernizr
 *
 * @namespace - models.Drawer
*/

slate.models = slate.models || {};

slate.models.Drawer = (function($, Modernizr) {

  var $document = $(document);
  var $body     = $(document.body);

  var selectors = {
    close: '[data-drawer-close]'
  };

  var classes = {
    drawer: 'drawer',
    visible: 'is-visible',
    backdrop: 'drawer-backdrop',
    backdropVisible: 'is-visible',
    bodyDrawerOpen: 'drawer-open'    
  };

 /**
  * Drawer constructor
  *
  * @param {HTMLElement | $} el - The drawer element
  * @param {Object} options
  */
  function Drawer(el, options) {

    this.name = 'drawer';
    this.namespace = '.'+this.name;

    this.$el = $(el);
    this.$backdrop              = null;
    this.stateIsOpen            = false;
    this.transitionEndEvent     = slate.utils.whichTransitionEnd();
    this.supportsCssTransitions = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;

    if(this.$el == undefined || !this.$el.hasClass(classes.drawer)) {
      //console.warn('['+this.name+'] - Element with class `'+classes.drawer+'` required to initialize.');
      return;
    }     

    var defaults = {
      closeSelector: selectors.close,
      backdrop: true
    };

    this.settings = $.extend({}, defaults, options);

    this.events = {
      HIDE:   'hide'   + this.namespace,
      HIDDEN: 'hidden' + this.namespace,
      SHOW:   'show'   + this.namespace,
      SHOWN:  'shown'  + this.namespace
    };    

    this.$el.on('click', this.settings.closeSelector, this.onCloseClick.bind(this));

  }

  Drawer.prototype = $.extend({}, Drawer.prototype, {

    addBackdrop: function(callback) {
      var _this = this;
      var cb    = callback || $.noop;

      if(this.stateIsOpen) {
        this.$backdrop = $(document.createElement('div'));

        this.$backdrop.addClass(classes.backdrop)
                      .appendTo($body);

        this.$backdrop.one(this.transitionEndEvent, cb);
        this.$backdrop.one('click', this.hide.bind(this))

        // debug this...
        setTimeout(function() {
          $body.addClass(classes.bodyDrawerOpen);          
          _this.$backdrop.addClass(classes.backdropVisible);
        }, 10);
      }
      else {
        cb();
      }
    },

    removeBackdrop: function(callback) {
      var _this = this;
      var cb    = callback || $.noop;

      if(this.$backdrop) {
        this.$backdrop.one(this.transitionEndEvent, function(){
          _this.$backdrop && _this.$backdrop.remove()
          _this.$backdrop = null;
          cb();
        });

        setTimeout(function() {
          _this.$backdrop.removeClass(classes.backdropVisible);
          $body.removeClass(classes.bodyDrawerOpen);
        }, 10);
      }
      else {
        cb();
      }
    },
    
    /**
     * Called after the closing animation has run
     */    
    onHidden: function() {
      this.stateIsOpen = false;
      var e = $.Event(this.events.HIDDEN);
      this.$el.trigger(e);
    },

    /**
     * Called after the opening animation has run
     */
    onShown: function() {
      var e = $.Event(this.events.SHOWN);
      this.$el.trigger(e);
    },

    hide: function() {
      var e = $.Event(this.events.HIDE);
      this.$el.trigger(e);

      if(this.stateIsOpen) {        
        this.$el.removeClass(classes.visible);

        if(this.settings.backdrop) {
          this.removeBackdrop();
        }        

        if(this.supportsCssTransitions) {
          this.$el.one(this.transitionEndEvent, this.onHidden.bind(this));
        }
        else {
          this.onHidden();
        }
      }     
    },

    show: function() {
      var e = $.Event(this.events.SHOW);
      this.$el.trigger(e);

      if(!this.stateIsOpen) {
        this.stateIsOpen = true;

        this.$el.addClass(classes.visible);

        if(this.settings.backdrop) {
          this.addBackdrop();
        }

        if(this.supportsCssTransitions) {
          this.$el.one(this.transitionEndEvent, this.onShown.bind(this));
        }
        else {
          this.onShown();
        }        
      }
    },

    toggle: function() {
      return this.stateIsOpen ? this.hide() : this.show();
    },

    onCloseClick: function(e) {
      e.preventDefault();
      this.hide();
    }
  });

  // DRAWER DATA-API
  // ===============

  $document.on('click.drawer', '[data-toggle="drawer"]', function (e) {

    var $this   = $(this)
    var $target = $($this.attr('data-target'));
    var options = $.extend($target.data(), $this.data());
    var data    = $this.data('drawer');

    if ($this.is('a')) e.preventDefault();

    if(!data) {
      $this.data('drawer', (data = new Drawer($target, options)));
      data.show();
    }
    else {
      data.toggle();
    }

  });  

  return Drawer;
  
}(jQuery, Modernizr));

/**
 * Model - Collection Sort
 * ------------------------------------------------------------------------------
 *
 * Dependencies
 *  - slate.utils
 *
 * @namespace - models.collectionSort
 */

 slate.models.CollectionSort = (function(){

  var $body = $(document.body);
  
  var selectors = {
    sortLink: '[data-sort-link]'
  };

  var classes = {
    sortLinkActive: 'is-active'
  }

  /**
   * CollectionSort constructor
   *
   * @param {HTMLElement} container - Container element used for scoping any element selection
   * @param {Object} collectionData - see the bottom of `sections/collection.liquid`
   */
  function CollectionSort(container, collectionData) {
    this.$container = $(container);

    this.name = 'collectionSort';
    this.namespace = '.'+this.name;

    // Stop parsing if we don't have the collection data
    if (!collectionData) {
      return;
    }

    this.collectionData = collectionData;

    this.$container.on('click', selectors.sortLink, this.applySort.bind(this));
  }

  CollectionSort.prototype = $.extend({}, CollectionSort.prototype, {
    applySort: function(e) {
      e.preventDefault();
      
      var $link  = $(e.currentTarget);
      var sortBy = $link.data('sort-link');
      var queryParams = slate.utils.getQueryParams();

      if($link.hasClass(classes.sortLinkActive) || sortBy == this.collectionData.sortDefault) {
        delete queryParams.sort_by;
      }
      else if(sortBy !== this.collectionData.sortDefault) {
        queryParams.sort_by = sortBy;
      }

      location.search = $.param(queryParams);
    }
  });

  return CollectionSort;
})();
/**
 * Tag Filter
 * ------------------------------------------------------------------------------
 *
 * @namespace - models.TagFilter
*/

slate.models = slate.models || {};

slate.models.TagFilter = (function($) {

  /**
   * TagFilter constructor.
   *
   * @param {String} type - Filter type (ex. "color", "size")
   * @param {String} value - Filter Value (ex. "color-blue", "size-small")
   * @param {String} title - Display title (ex. "Blue", "Extra Large")
   * @param {Bool} active - You can specify that the filter is active when you construct it
   */
  function TagFilter(type, value, title, active) {
    if(!type || !value) {
      return;
    }

    this.type   = type;
    this.value  = value;
    this.title  = title;
    this.active = active || false;

    return this;
  };

  TagFilter.prototype = {
    activate: function() {
      this.active = true;
      return this;
    },

    deactivate: function() {
      this.active = false;
      return this;
    }
  };

  return TagFilter;
}(jQuery));
/**
 * Tag Filter Controller
 * ------------------------------------------------------------------------------
 *
 * @namespace - models.TagFilterController
*/

slate.models = slate.models || {};

slate.models.TagFilterController = (function($) {

  /**
   * TagFilterController constructor.
   * - Manages the tag filters applied to the collection page.
   * - All modifications to / queries for filters should go through this guy
   *
   */
  function TagFilterController() {

    this.name = 'tagFilterController';
    this.tagFilters = [];

    /**
     * Constructs an object of tag filter data to be consumed by other functions inside this controller
     *
     * @return {Object} obj
     * @return {Array}  obj.types
     * @return {Array}  obj.activeTypes
     * @return {Array}  obj.values
     * @return {Array}  obj.activeValues
     * @return {Object} obj.filtersForType
     */
    this._getTagFilterData = function() {
      var data = {
        types: [],
        activeTypes: [],
        actives: [],
        values: [],
        activeValues: [],
        filtersForType: {}
      };

      for (var i = this.tagFilters.length - 1; i >= 0; i--) {
        var tf   = this.tagFilters[i];
        var val  = tf.value;
        var type = tf.type;
        
        // Update data.types
        if(data.types.indexOf(type) == -1) {
          data.types.push(type);
        }
        
        // Update data.values
        if(data.values.indexOf(val) == -1) {
          data.values.push(val);
        }
        
        // Update data.filtersForType
        if(!data.filtersForType.hasOwnProperty(type)) {
          data.filtersForType[type] = [];
        }

        data.filtersForType[type].push(tf);

        // Update data.actives / data.activeTypes / data.activeValues
        if(tf.active) {
          data.actives.push(tf);
          if(data.activeTypes.indexOf(type) == -1) {
            data.activeTypes.push(type);
          }
          if(data.activeValues.indexOf(val) == -1) {
            data.activeValues.push(val);
          }
        }

      }

      return data;
    },

    /**
     * Register an instance of a TagFilter
     *
     * @param {TagFilter} tagFilter
     */
    this.registerTagFilter = function(tagFilter) {    
      this.tagFilters.push(tagFilter);
    };

    this.activateTagFilterByValue = function(val) {
      // console.log('['+this.name+'] ActivateTagFilterByValue - ' + val);
      var tf = this.getTagFilterByValue(val);

      if(tf) {
        tf.activate();
      }
    };

    this.deactivateTagFilterByValue = function(val) {
      // console.log('['+this.name+'] DeactivateTagFilterByValue - ' + val);
      var tf = this.getTagFilterByValue(val);

      if(tf) {
        tf.deactivate();
      }
    };

    this.toggleFilterByValue = function(val){
      var tf = this.getTagFilterByValue(val);
      if(tf) {
        tf.active ? tf.deactivate() : tf.activate();
      }
    };

    this.deactivateAllFilters = function() {
      $.each(this.getActiveTagFilters(), function(i, tf){
        tf.deactivate();
      });
    }

    this.getTagFilterTypes = function() {
      return this._getTagFilterData().types;
    };

    this.getActiveTagFilterTypes = function() {
      return this._getTagFilterData().activeTypes;
    };

    this.getActiveTagFilterValues = function() {
      return this._getTagFilterData().activeValues;
    };

    this.getTagFiltersForType = function(type) {
      var filterData = this._getTagFilterData();

      return filterData.filtersForType.hasOwnProperty(type) ? filterData.filtersForType[type] : [];
    };

    this.getActiveTagFilters = function() {
     return this._getTagFilterData().actives;
    };

    this.getActiveTagFiltersForType = function(type) {
      var tfs = this.getTagFiltersForType(type);

      return tfs.filter(function(f) { return f.active; });
    };

    this.getTagFilterByValue = function(val) {
      for (var i = this.tagFilters.length - 1; i >= 0; i--) {
        var tf = this.tagFilters[i];
        if(tf.value == val) {
          return tf;
        }
      }
    };

    this.getTagFilters = function() {
      return this.tagFilters;
    };
  };

  return TagFilterController;
}(jQuery));
/**
 * Audio Description
 * ------------------------------------------------------------------------------
 *
 * @namespace - models.AudioDescription
*/

slate.models = slate.models || {};

slate.models.AudioDescription = (function($) {

  var selectors = {
    status: '[data-status]'
  };

  var classes = {
    isPlaying: 'is-playing'
  };

  var states = {
    PLAYING: 1,
    STOPPED: 2
  };

  /**
   * AudioDescription constructor.
   *
   * @param {el | jQuery} el
   */
  function AudioDescription(el) {
    this.$el = $(el)

    if(!this.$el || this.$el.length === 0 ) {
      return;
    }

    this.$audioEl = this.$el.find('audio');
    this.audioEl = this.$audioEl.get(0);
    this.$status = $(selectors.status, this.$el);    
    
    this.playing = false;
    this.startLabel = this.$el.data('start-label') || this.$status.text() || 'Listen to Dill';
    this.stopLabel = this.$el.data('stop-label') || 'Stop Commentary';

    this.$el.on('click', this.onClick.bind(this));
    this.$audioEl.on('playing play', this.setState.bind(this, states.PLAYING));
    this.$audioEl.on('pause stalled', this.setState.bind(this, states.STOPPED));
    this.$audioEl.on('ended', this.onEnded.bind(this));
  };

  AudioDescription.prototype = {
    setState: function(state) {
      switch(state) {
        case states.PLAYING:
          this.$el.addClass(classes.isPlaying);
          this.$status.text(this.stopLabel); 
          this.playing = true;
          break;
          
        case states.STOPPED:
          this.$el.removeClass(classes.isPlaying);
          this.$status.text(this.startLabel);  
          this.playing = false
          break;
      }
    },
    onEnded: function(e) {
      this.setState(states.STOPPED);
      this.audioEl.currentTime = 0;
    },
    onClick: function(e) {
      this.playing ? this.stopAudio() : this.startAudio();
    },
    startAudio: function() {
      this.audioEl.currentTime = 0;
      this.audioEl.play();
    },
    stopAudio: function() {
      this.audioEl.pause();
      this.audioEl.currentTime = 0;
    }
  }

  return AudioDescription;
}(jQuery));
/**
 * Model - Dropdown
 * -----------------------------------------------------------------------------
 * Dropdowns are just elements that respond to a visibility class in order to hide and show
 *
 * @namespace models.dropdown
 */

 slate.models = slate.models || {};

 slate.models.DropdownMenu = (function($) {

  var classes = {
    active: 'is-active'
  };  

  /**
   * Dropdown - Exposes methods for opening and closing the dropdown.  All logic is handled externally
   *
   * @constructor
   * @param {jQuery} $trigger - Element with attributes 'data-dropdown-menu-trigger'
   */
  function DropdownMenu($trigger) {
    this.$trigger = $trigger;
    this.$el      = $(this.$trigger.data('dropdown-menu-trigger'));
  };

  DropdownMenu.prototype = {
    isOpen: function() {
      return this.$el.hasClass(classes.active);
    },
    open: function() {
      this.$el.addClass(classes.active);
    },
    close: function() {
      this.$el.removeClass(classes.active);
    }
  };

  return DropdownMenu;
 }(jQuery));
/**
 * Model - Dropdown
 * -----------------------------------------------------------------------------
 *
 * @namespace models.Dropdown
 */

 slate.models = slate.models || {};

 slate.models.Dropdown = (function($) {

  var classes = {
    open: 'is-open'
  };

  var $window = $(window);

  /**
   * DropdownManager - Manages opening / closing of all dropdowns.  Makes sure only one shows at a time.
   *
   * @constructor
   * @param {function} dropdownConstructor
   */
  function Dropdown($el) {
    this.$el = $el;
    this.closeDropdownTimeout = null;
    this.closeDropdownTimeoutDuration = 80;
    this.dropdownCloseAnimationTimeout = null;
    this.dropdowns = [];
    this.activeDropdown = undefined;
    this.scrollPositionOnLastOpen = 0;
    this.isOpen = false;

    this.events = window.PointerEvent ? {
                  end:   "pointerup",
                  enter: "pointerenter",
                  leave: "pointerleave"
                } : {
                  end: "touchend",
                  enter: "mouseenter",
                  leave: "mouseleave"
                };

  };

  Dropdown.prototype = {
    register: function($trigger) {
      var dd = new slate.models.DropdownMenu($trigger);

      // Trigger events - the link that you interact with to display the dropdown
      dd.$trigger.on(this.events.enter,  this.onTriggerMouseEnter.bind(this, dd));
      dd.$trigger.on(this.events.leave,  this.onTriggerMouseLeave.bind(this, dd));
      dd.$trigger.on(this.events.end,    this.onTriggerTouchEnd.bind(this, dd));

      // Dropdown events - what happens when you interact with the dropdown itself
      dd.$el.on(this.events.leave, this.onDropdownMouseLeave.bind(this, dd));
      dd.$el.on(this.events.enter, this.onDropdownMouseEnter.bind(this, dd));
      dd.$el.on(this.events.end,   this.onDropdownTouchEnd.bind(this, dd));

      this.dropdowns.push(dd);
    },

    onTriggerMouseEnter: function(dd, e) {
      if(e.pointerType != "touch") {
        this.stopCloseTimeout();
        this.openDropdown(dd);
      }
    },

    onTriggerMouseLeave: function(dd, e) {
      if(e.pointerType != "touch") {
        this.startCloseTimeout(dd);
      }
    },

    onTriggerTouchEnd: function(dd, e) {
      e.preventDefault();
      e.stopPropagation();
      this.toggleDropdown(dd);
    },

    onDropdownMouseEnter: function(dd, e) {
      if(e.pointerType != "touch") {
        this.stopCloseTimeout();
      }
    },

    onDropdownMouseLeave: function(dd, e) {
      if(e.pointerType != "touch") {
        this.startCloseTimeout(dd);
      }
    },

    onDropdownTouchEnd: function(dd, e) {
      e.stopPropagation();
    },

    toggleDropdown: function(dd) {
      return this.activeDropdown == dd ? this.closeDropdown(dd) : this.openDropdown(dd);
    },

    openDropdown: function(dd) {
      clearTimeout(this.dropdownCloseAnimationTimeout);

      if(this.activeDropdown && this.activeDropdown !== dd) {
        this.activeDropdown.close();
      }

      dd.open();
      this.activeDropdown = dd;

      this.$el.addClass(classes.open);
      this.isOpen = true;
      this.scrollPositionOnLastOpen = $window.scrollTop();
    },

    closeDropdown: function(dd) {
      this.$el.removeClass(classes.open); // Just hide the whole thing

      this.dropdownCloseAnimationTimeout = setTimeout(() => {
        this.activeDropdown && this.activeDropdown.close();
        this.activeDropdown = null;
        this.isOpen = false;
      }, 125);
    },

    startCloseTimeout: function(dd) {
      this.closeDropdownTimeout = setTimeout(this.closeDropdown.bind(this, dd), this.closeDropdownTimeoutDuration);
    },

    stopCloseTimeout: function() {
      clearTimeout(this.closeDropdownTimeout);
    },

    onScroll: function(scrollTop) {
      if (!this.isOpen) return;

      // On touch screens there's no mouseleave, you can only close by clicking the trigger
      // Let's make it a little nicer by closing the dropdown when they scroll down a little bit further
      if (Math.abs(scrollTop - this.scrollPositionOnLastOpen) > 25) {
        this.closeDropdown();
      }
    }
  };

  return Dropdown;
 }(jQuery));
/**
 * Model - NewsletterForm
 * -----------------------------------------------------------------------------
 *
 * @namespace models.NewsletterForm
 */

 slate.models = slate.models || {};

 slate.models.NewsletterForm = (function($, Modernizr) {

  var selectors = {
    form: 'form',
    formContents: '[data-form-contents]',
    formMessage: '[data-form-message]' // needs data-success, data-already-subscribed, data-fail
  };

  var classes = {
    showMessage: 'show-message',
  };

  /**
   * NewsletterForm constructor
   *
   * @param {HTMLElement} el - Element used for scoping any element selection.  Can either be a containing element or the form element itself
   */ 
  function NewsletterForm(el) {
    this.name = 'newsletterForm';

    this.transitionEndEvent     = slate.utils.whichTransitionEnd();
    this.supportsCssTransitions = !!Modernizr.csstransitions;

    this.$el = $(el);
    this.$form = this.$el.is(selectors.form) ? this.$el : this.$el.find(selectors.form);
    this.timeout = null;
    
    if (!this.$form.length) {
      console.warn(`[${this.name}] - Form element required to initialize`);
      return;
    }

    this.$formContents = $(selectors.formContents, this.$el);
    this.$formMessage  = $(selectors.formMessage, this.$el);
  };

  NewsletterForm.prototype = {
    /**
     * Temporarily shows the form message
     *
     * @param {Boolean} reset - If set, will call this.reset
     */  
    showMessageWithTimeout(reset = false) {
      this.$formContents.addClass(classes.showMessage);

      window.clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        if (reset) {
          this.reset();
        }
        else {
          this.$formContents.removeClass(classes.showMessage);
        }        
      }.bind(this), 4000);
    },

    /**
     * Resets everything to it's initial state.  Only call when form content isn't visible
     */
    reset: function() {
      this.$form.find('input[type="email"]').val('');
      this.$form.find('input[type="checkbox"]').prop('checked', false);

      const cb = this.$formMessage.html.bind(this.$formMessage, '');

      if (this.supportsCssTransitions) {
        this.$formContents.one(this.transitionEndEvent, cb);
      }
      else {
        setTimeout(cb, slate.animations.getTransitionTimingDuration('base'));
      }

      this.$formContents.removeClass(classes.showMessage);
    },

    onSubscribeSuccess: function(response) {
      const isSubscribed = response && response.data && response.data.is_subscribed;
      const successMsg = this.$formMessage.data(isSubscribed ? 'already-subscribed' : 'success');

      this.$formMessage.html(successMsg);

      // Don't reset the form if they're already subscribed, they might want to just enter a different email
      this.showMessageWithTimeout(!isSubscribed);
    },

    onSubmitFail: function(errors) {
      this.$formMessage.html(Array.isArray(errors) ? errors.join('  ') : errors);
      this.showMessageWithTimeout();
    },

    onSubscribeFail: function() {
      this.$formMessage.html(this.$formMessage.data('fail'));
      this.showMessageWithTimeout();
    }
  };

  return NewsletterForm;
 }(jQuery, Modernizr));


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 * Uses slate.productDetailForm to handle core product form functionality.
 *
 * - Attaches the `Product` constructor to window.theme.Product.
 *
 * Requires:
 *  - jQuery
 *  - jQuery.fn.zoom - http://www.jacklmoore.com/zoom/
 *  - Slate
 *
 * See:
 * - product.liquid
 * - product-detail-form.liquid
 *
 * @namespace product
 */

theme.Product = (function($, slate) {

  var selectors = {
    productDetailForm: '[data-product-detail-form]',
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    this.settings = {};
    this.name = 'product';
    this.namespace = '.'+this.name;

    var productDetailForm = new slate.ProductDetailForm({
      $el: $(selectors.productDetailForm, this.$container).first(),
      enableHistoryState: this.$container.data('enable-history-state') || false,
      enableZoom: this.$container.data('zoom-enabled') || false
    });

    productDetailForm.initialize();
  };

  return Product;
})(jQuery, slate);

/**
 * Product Preview Section Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly coupled to the product preview section.
 *
 * - Attaches the `ProductPreview` constructor to window.theme.ProductPreview.
 *
 * Requires:
 *  - jQuery
 *  - Slate
 *
 * See:
 * - product-preview.liquid
 * - product-preview-detail-form.liquid
 *
 * @namespace productPreview
 */

theme.ProductPreview = (function($, slate) {

  var selectors = {
    detailForm: '[data-product-detail-form]',
    audioDescription: '[data-product-audio-description]'
  };
  
  /**
   * Product Preview section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function ProductPreview(container) {
	//console.log('productPreview', container);
    this.$container = $(container);

    this.settings = {};
    this.name = 'productPreview';
    this.namespace = '.'+this.name;

    this.$detailForm = $(selectors.detailForm, this.$container);

    this.audioDescription = new slate.models.AudioDescription($(selectors.audioDescription, this.$container));

    this.$detailForm.imagesLoaded(function() {
      this.$detailForm.addClass('is-ready');
    }.bind(this));
  };

  return ProductPreview;
})(jQuery, slate);

/**
 * Product Display Only Section Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the product display only section.
 *
 * - Attaches the `ProductDisplayOnly` constructor to window.theme.ProductDisplayOnly
 * - Kind of a mashup between the normal pdp layout plus the preview functionality
 *
 * Requires:
 *  - jQuery
 *  - Slate
 *
 * See:
 * - product-display-only.liquid
 * - product-display-only-detail-form.liquid
 *
 * @namespace productDisplayOnly
 */

theme.ProductDisplayOnly = (function($, Modernizr, slate) {

  var selectors = {
    productGallery: '[data-product-gallery]',
    audioDescription: '[data-product-audio-description]'
  };
  
  /**
   * Product display only section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for thfe section container DOM element
   */
  function ProductDisplayOnly(container) {
	this.$container = $(container);

    this.settings = {};
    this.name = 'productDisplayOnly';
    this.namespace = '.'+this.name;

    this.audioDescription = new slate.models.AudioDescription($(selectors.audioDescription, this.$container));
    this.gallery = new slate.ProductDetailGallery($(selectors.productGallery, this.$container));

    this.$container.find('.product-detail-form').addClass('is-ready');
  };

  return ProductDisplayOnly;
})(jQuery, Modernizr, slate);

/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
 * @namespace collection
 */

 theme.Collection = (function(slate) {

  var selectors = {
    collectionJson: '[data-collection-json]',
    filterTagsRow: '.collection-filter-tags__row',
    filterTags: '[data-filter-type][data-filter-tags]',
    filterControls: '[data-filter-controls]',
    filterControlsToggle: '[data-filter-controls-toggle]',
    sortControls: '[data-sort-controls]',
    sortControlsToggle: '[data-sort-controls-toggle]',
    collectionFilterEmpty: '[data-collection-filter-empty]',
    productCard: '[data-product-card]',
    productGridItem: '.content-grid__item',
    clearAllFilters: '[data-clear-all-filters]'
  };

  var classes = {
    filterActive: 'is-active',
    filterControlsOpen: 'is-open',
    filterConTrolsToggleHasActiveFilters: 'has-active-filters',
    sortControlsOpen: 'is-open',
  };

  var $window = $(window);
  
  function Collection(container) {
    var self = this;

    this.$container = $(container);

    this.name = 'collection';
    this.namespace = '.'+this.name;

    // Stop parsing if we don't have the collection json script tag
    if (!$(selectors.collectionJson, this.$container).html()) {
      //console.warn('['+this.name+'] - Element matching ' + selectors.collectionJson + ' required.')
      return;
    }

    this.queryStringFilterParamKey      = 'filters';
    this.collectionData                 = JSON.parse($(selectors.collectionJson, this.$container).html());

    this.$filterTags                    = $(selectors.filterTags, this.$container);
    this.$filterTagsRows                = $(selectors.filterTagsRow, this.$container);
    this.$clearAllFilters               = $(selectors.clearAllFilters, this.$container);
    this.$filterControls                = $(selectors.filterControls, this.$container);
    this.$filterControlsToggle          = $(selectors.filterControlsToggle, this.$container);
    this.$sortControls                  = $(selectors.sortControls, this.$container);
    this.$sortControlsToggle            = $(selectors.sortControlsToggle, this.$container);
    this.$productCards                  = $(selectors.productCard, this.$container);
    this.$productGridItems              = $(selectors.productGridItem, this.$container);
    this.$collectionFilterEmpty         = $(selectors.collectionFilterEmpty, this.$container);

    this.tagFilterController            = new slate.models.TagFilterController();
    this.sort                           = new slate.models.CollectionSort(this.$container, this.collectionData);

    // Sort the tag filters since it's much easier to do in JS than in liquid
    this.$filterTagsRows.each(function() {
      var $row = $(this);
      var $filterTags = $row.find(selectors.filterTags);

      $filterTags.detach();

      $filterTags.sort(function(a, b) {
        // This way we only sort numberic sizes
        var an = parseFloat(a.innerText);
        var bn = parseFloat(b.innerText);

        return an > bn ? 1 : (an < bn ? -1 : 0);
      });

      $row.append($filterTags);
    });

    // Register all the tag filters
    this.$filterTags.each(function() {
      var $ft   = $(this);
      var type  = $ft.data('filter-type');
      var title = $ft.attr('title') && $ft.attr('title').length ? $ft.attr('title') : $ft.text();
      var tags  = $ft.data('filter-tags').split(" "); // Handle single filterElements that map to multiple tags (space separated)

      $.each(tags, function(i, value) {
        self.tagFilterController.registerTagFilter( new slate.models.TagFilter(type, value, title) );
      });
    });

    // When we load the page, check for filter tag parameters in the URL
    var queryParams = slate.utils.getQueryParams();
    var queryParamFilters = [];

    if(queryParams.hasOwnProperty(this.queryStringFilterParamKey) && queryParams[ this.queryStringFilterParamKey ].length) {
      
      queryParamFilters = decodeURIComponent(queryParams[ this.queryStringFilterParamKey ]).split('+');

      $.each(queryParamFilters, function(i, param) {
        self.tagFilterController.activateTagFilterByValue(param);
      });
    }

    // Add event handlers
    this.$container.on('click', selectors.filterTags, this.onFilterTagsClick.bind(this));
    this.$container.on('click', selectors.clearAllFilters, this.onClearAllFiltersClick.bind(this));
    this.$container.on('click', selectors.filterControlsToggle, this.onFilterControlsToggleClick.bind(this));
    this.$container.on('click', selectors.sortControlsToggle, this.onSortControlsToggleClick.bind(this));

    if(this.tagFilterController.getActiveTagFilters().length) {
      this.openFilters();
      this.applyTagFilters();
    }
  }

  Collection.prototype = $.extend({}, Collection.prototype, {

    /**
     * Returns a jQuery set of product card elements that satisfy the currently applied filtering
     * If there are no filters, we return the entire set of cards
     *
     * @return {jQuery}
     */
    getProductCardsThatPassAppliedFilters: function() {
      var self = this;
      // Need to create *new* copies of the product card set
      var $productCardSetFilterOut     = $(selectors.productCard, this.$container); // Start with all the cards, and filter out the ones that pass, leaving the ones that need to be hidden
      var $productCardSetNonFilterable = $(selectors.productCard, this.$container).filter('[data-not-filterable]'); // These cards are immune to the filtering state
      var activeFilterTypes            = this.tagFilterController.getActiveTagFilterTypes();
      var activeTagFilters             = this.tagFilterController.getActiveTagFilters();
      var filterTypes                  = this.tagFilterController.getTagFilterTypes();

      // We don't have active filters - show everything, nothing needs to be hidden!
      if(!activeFilterTypes.length) {
        return this.$productCards;
      }

      // We DO have active filters - Loop through each product card
      this.$productCards.each(function(i){
        var passesActiveFilters = true; // If this is still "true" at the end of all this logic, then the product passes the applied filters and should be displayed
        var $productCard       = $(this);
        var dataTags           = $productCard.data('tags');
        
        // If there aren't any tags, return early
        if (!dataTags) {
          passesActiveFilters = false;
          return;
        }

        // Loop through each active filter
        for (var i = activeFilterTypes.length - 1; i >= 0; i--) {
          var activeFilterTypeMatch        = false;
          var activeTagFiltersForType      = self.tagFilterController.getActiveTagFiltersForType( activeFilterTypes[i] ); // [TagFilter, TagFilter]
          var activeTagFilterValuesForType = activeTagFiltersForType.map(function(tf){ return tf.value; }); // ["color-blue", "color-red"]

          for (var k = activeTagFilterValuesForType.length - 1; k >= 0; k--) {
            var activeTagFilterVal = activeTagFilterValuesForType[k]; // "color-blue"

            // as soon as we find a match for this filter type (doesn't matter which value), return it as a match
            // this is how we satisfy the requirement to match ANY filter for a particular filter type (match "red" OR "blue")
            if(dataTags.indexOf(activeTagFilterVal) != -1) {
              activeFilterTypeMatch = true;
              break;
            }
          }
          
          // Not a match :(
          if(activeFilterTypeMatch == false) {
            passesActiveFilters = false;
            break;
          }
        }

        if(passesActiveFilters) {
          $productCardSetFilterOut = $productCardSetFilterOut.not($productCard); // remove it from the matched set
        }
      });

      var $passingCards = this.$productCards.not($productCardSetFilterOut);

      return $passingCards.length === 0 ? $passingCards : $passingCards.add($productCardSetNonFilterable);
    },

    /**
     * Handle filter tags element click event.
     * Toggles the state of the filter that was clicked on and then applies the tag filters to the collection
     *
     * @param {event} evt
     */
    onFilterTagsClick: function(e) {
      e.preventDefault();

      var self          = this;
      var $filterTagsEl = $(e.currentTarget);
      var tags          = $filterTagsEl.data('filter-tags').split(" ");

      if(tags.length == 0) return;

      $.each(tags, function(i, t) {
        self.tagFilterController.toggleFilterByValue(t);
      });

      self.applyTagFilters();
    },

    onClearAllFiltersClick: function(e) {
      e.preventDefault();
      this.tagFilterController.deactivateAllFilters();
      this.applyTagFilters()
    },

    onFilterControlsToggleClick: function(e) {
      e.preventDefault();

      if(this.$filterControlsToggle.hasClass(classes.filterControlsOpen)) {
        this.closeFilters();
      }
      else {
        this.openFilters();
        this.closeSort();
      }
    },

    onSortControlsToggleClick: function(e) {
      e.preventDefault();

      if(this.$sortControlsToggle.hasClass(classes.sortControlsOpen)) {
        this.closeSort();
      }
      else {
        this.openSort();
        this.closeFilters();
      }
    },

    /**
     * Updates the filter UI to reflect the state of active / deactive filters
     *
     */
    updateFilterUI: function() {
      var self = this;
      var filters = this.tagFilterController.getTagFilters();
      var activeFilters = this.tagFilterController.getActiveTagFilters();

      $.each(filters, function(i, f) {

        var $filterTag = self.$filterTags.filter(function(){

          var $currentTag = $(this);
          var $found;

          $.each($currentTag.data('filter-tags').split(" "), function(i, val){
            if(val == f.value) {
              $found = $currentTag;
              return false;
            }
          });

          return $found;
        });

        f.active ? $filterTag.addClass(classes.filterActive) : $filterTag.removeClass(classes.filterActive);

      });

      if(activeFilters.length) {
        this.$clearAllFilters.show();
        this.$filterControlsToggle.addClass(classes.filterConTrolsToggleHasActiveFilters);
      }
      else {
        this.$clearAllFilters.hide();
        this.$filterControlsToggle.removeClass(classes.filterConTrolsToggleHasActiveFilters);
      }
    },

    /**
     * Updates the current URL to reflect the state of the applied filters
     * Appends a query string like ?filter-tags={{ tag1 }}+{{ tag2 }}
     *
     */
    updateURL: function() {
      var queryStringFilterParamValues = this.tagFilterController.getActiveTagFilterValues().join('+');
      var updatedUrl;

      if(window.history) {
        if(queryStringFilterParamValues.length) {
          updatedUrl = slate.utils.getUrlWithUpdatedQueryStringParameter(this.queryStringFilterParamKey, queryStringFilterParamValues);
        }
        else {
          updatedUrl = slate.utils.getUrlWithRemovedQueryStringParameter(this.queryStringFilterParamKey);
        }
        
        window.history.replaceState({ path: updatedUrl }, '', updatedUrl);
      }
    },

    closeFilters: function() {
      if(!this.$filterControlsToggle.length || !this.$filterControls.length) return;
      this.$filterControlsToggle.removeClass(classes.filterControlsOpen);
      this.$filterControls.hide();
    },

    openFilters: function() {
      if(!this.$filterControlsToggle.length || !this.$filterControls.length) return;
      this.$filterControlsToggle.addClass(classes.filterControlsOpen);
      this.$filterControls.show();
    },

    closeSort: function() {
      if(!this.$sortControlsToggle.length || !this.$sortControls.length) return;
      this.$sortControlsToggle.removeClass(classes.sortControlsOpen);
      this.$sortControls.hide();
    },

    openSort: function() {
      if(!this.$sortControlsToggle.length || !this.$sortControls.length) return;
      this.$sortControlsToggle.addClass(classes.sortControlsOpen);
      this.$sortControls.show();
    },

    /**
     * Applies the currently active filters to the collection page
     *
     * @return {self}
     */
    applyTagFilters: function() {
      var self = this;
      var cb;
      var $productCardSetThatPasses = this.getProductCardsThatPassAppliedFilters();
      var passingProductCardCount   = $productCardSetThatPasses.length;

      // Nothing Matches
      if(passingProductCardCount == 0) {  
        self.$collectionFilterEmpty.show();
        cb = function() {
          self.$productGridItems.hide();
          // self.fadeInProductGrid();
        };
      }
      // Everything matches
      else if(passingProductCardCount == this.$productCards.length) {
        self.$collectionFilterEmpty.hide();
        cb = function() {
          self.$productGridItems.show();
          // self.fadeInProductGrid();
        }
      }
      // Partial match
      else {
        self.$collectionFilterEmpty.hide();
        cb = function() {
          self.$productGridItems.hide();
          $productCardSetThatPasses.parent(selectors.productGridItem).show();
          // self.fadeInProductGrid();
        }
      }

      // this.fadeOutProductGrid(cb);
      cb();

      self.updateFilterUI();
      self.updateURL();

      return this;
    }
  });

  return Collection;

 })(slate)
/**
 * Pencil Banner Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the opening and closing of the banner
 *
 * @namespace - pencilBanner
 */

theme.PencilBanner = (function($, Cookies) {

  var $window = $(window);

  var selectors = {
    goal: '[data-goal]'
  };

  /**
   * Pencil Banner section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function PencilBanner(container) {
    this.$container = $(container);

    this.name = 'pencilBanner',
    this.namespace = '.'+this.name;

    this.goalEnabled = this.$container.data('goal-enabled') || false;

    // For international users, GlobalE replaces the content of the pencil banner
    // In this case, we need to return early and not worry about goal functionality that won't work
    var globalECookie = Cookies.get('GlobalE_Data');
    var globalEEnabled = !!theme.globalEEnabled;
    
    if(globalEEnabled && globalECookie !== undefined && JSON.parse(globalECookie).countryISO !== "US") {
      return;
    }

    if(this.goalEnabled) {
      this.$goal = $(selectors.goal, this.$container);
      this.goalAmount = parseFloat(this.$goal.data('goal-amount'));
      this.goalRemainingPre = this.$goal.data('goal-remaining-pre');
      this.goalRemainingPost = this.$goal.data('goal-remaining-post');
      this.goalSuccessMessage = this.$goal.data('goal-success-message');
      this.goalPitch = this.$goal.data('goal-pitch');

      $window.on('render.ajaxCart', this.onAjaxCartRender.bind(this));
    }
  }

  PencilBanner.prototype = $.extend({}, PencilBanner.prototype, {
   /**
    * Set the correct goal message based on the cartTotal passed in
    *
    * @param {number} cartTotal - float number like '55.45'
    */
    setGoalMessage: function(cartTotal) {
      if(!this.goalEnabled) return;

      var msg;
      var remaining;

      if(cartTotal == 0) {
        msg = this.goalPitch;
      }
      else if(cartTotal > this.goalAmount) {
        msg = this.goalSuccessMessage;
      }
      else {
        remaining = this.goalAmount - cartTotal;
        remaining = remaining * 100; // Shopify works in cents
        remaining = slate.Currency.formatMoney(remaining, theme.moneyFormat); // Format it nicely
        remaining = slate.Currency.stripZeroCents(remaining); // strip cents

        msg = this.goalRemainingPre + ' ' + remaining + ' ' + this.goalRemainingPost;
      }

      this.$goal.html(msg);
    },

   /**
    * Update the pencil banner text based on cart amount if we need to
    *
    * @param {Event} e - event
    * @param {Object} e.cart - Shopify Cart object
    */
    onAjaxCartRender: function(e) {
      if(e && e.cart) {
        var cartTotal = e.cart.original_total_price/100;
        this.goalEnabled && this.setGoalMessage(cartTotal);
      }
    }
  });

  return PencilBanner;
})(jQuery, Cookies);

/**
 * Header Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - header
 */

theme.Header = (function($) {

  var $window = $(window);
  var $body   = $(document.body);

  var selectors = {
    header: '[data-header]',
    search: '[data-header-search]',
    searchToggle: '[data-search-toggle]',
    searchClose: '[data-search-close]',
    dropdown: '[data-dropdown]',
    dropdownMenuTrigger: '[data-dropdown-menu-trigger]',
    dropdownMenu: '[data-dropdown-menu]'
  };

  var classes = {
    headerFixed: 'is-fixed',
    searchActive: 'is-active',
    searchInteractive: 'is-interactive',
    searchHasError: 'has-error'
  };

  function Header(container) {
    var self = this;

    this.name = 'header';
    this.namespace = '.'+this.name;
    this.events = {
      SCROLL: 'scroll' + this.namespace
    };

    this.$container = $(container);
    this.$el = $(selectors.header, this.$container);
    this.$dropdown = $(selectors.dropdown, this.$container);

    this.dropdown = new slate.models.Dropdown(this.$dropdown);

    // Register each dropdown trigger
    $(selectors.dropdownMenuTrigger, this.$container).each(function(i, trigger) {
      self.dropdown.register($(trigger));
    });    

    this.$search = $(selectors.search, this.$container);
    this.$searchInput = this.$search.find('input[type="search"]');

    this.$container.on('click', selectors.searchToggle, this.onSearchToggleClick.bind(this));
    this.$container.on('click', selectors.searchClose, this.onSearchCloseClick.bind(this));
    this.$search.on('submit', this.onSearchSubmit.bind(this));
    this.$searchInput.on('keydown', this.onSearchInputKeydown.bind(this));
    this.$searchInput.on('input', this.onSearchInputChange.bind(this));

    $window.on(this.events.SCROLL, $.throttle(50, this.onScroll.bind(this)));
    this.onScroll(); // hit this one time on init to make sure everything is good 
  };

  Header.prototype = $.extend({}, Header.prototype, {
    scrollCheck: function(scrollTop) {
      // Do measurements outside of rAF.
      var actualOffset = this.$container.offset()['top'] - this.$el.outerHeight();
      var applyClass = scrollTop >= actualOffset

      // Do DOM updates inside.
      requestAnimationFrame(function() {
        this.$el.toggleClass(classes.headerFixed, applyClass);
      }.bind(this));
    },

    removeSearchInputError: function(e) {
      this.$search.removeClass(classes.searchHasError);
    },

    openSearch: function() {
      this.$search.addClass(classes.searchActive);
    },

    closeSearch: function() {
      this.$search.removeClass(classes.searchActive);

      setTimeout(function() {
        this.$searchInput.val('');
        this.$search.removeClass(classes.searchInteractive);
      }.bind(this), 350);
    },

    onScroll: function() {
      var scrollTop = $window.scrollTop();
      this.scrollCheck(scrollTop);
      this.dropdown.onScroll(scrollTop);
    },

    onSearchSubmit: function() {
      var q = this.$searchInput.val();

      if(this.$searchInput.length && (!q || 0 === q.length)) {
        this.$search.addClass(classes.searchHasError);
        this.$searchInput.focus();
        return false;
      }
    },

    onSearchInputKeydown: function(e) {
      if (e.which === 27) {
        this.closeSearch();
      }
    },

    onSearchInputChange: function(e) {
      this.$search.addClass(classes.searchInteractive);
      this.removeSearchInputError();  
    },

    onSearchCloseClick: function(e) {
      e.preventDefault();
      this.closeSearch();
    },

    onSearchToggleClick: function(e) {
      e.preventDefault();

      if (this.$search.hasClass(classes.searchActive)) {
        this.closeSearch();
      }
      else {
        this.openSearch();
        this.$searchInput.focus();
      }
    }  
  });

  return Header;
})(jQuery);

/**
 * Footer Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - footer
 */

theme.Footer = (function($, slate) {

  var selectors = {
    newsletterForm: '[data-newsletter-form]'
  };  

  function Footer(container) {
    var self = this;
    this.$container = $(container);

    var $newsletterForm = $(selectors.newsletterForm, this.$container);

    if ($newsletterForm.length) {
      this.newsletterForm = new slate.models.NewsletterForm($newsletterForm);

      this.ajaxForm = new slate.AjaxKlaviyoForm($newsletterForm, {
        listId: $newsletterForm.data('klaviyo-list-id'),
        source: $newsletterForm.data('klaviyo-source'),
        onSubmitFail: function(errors) {
          self.newsletterForm.onSubmitFail(errors);
        },
        onSubscribeSuccess: function(response) {
          self.newsletterForm.onSubscribeSuccess(response);
        },
        onSubscribeFail: function(response) {
          self.newsletterForm.onSubscribeFail(response);
        }
      });
    }
  };

  return Footer;
})(jQuery, slate);

/**
 * Ajax Cart Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the interacting with the ajax cart section.
 * All logic is handled in slate.AjaxCart, this file is strictly for handling section settings and them editor interactions
 *
 * @namespace - ajaxCart
 */

theme.AjaxCart = (function($) {

  var $body = $(document.body);

  /**
   * AjaxCart section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function AjaxCart(container) {
    this.$container = $(container);

    this.name = 'ajaxCart',
    this.namespace = '.'+this.name;

    this.ajaxCart = new slate.AjaxCart();

    if (!$body.hasClass('template-cart')) {
      this.ajaxCart.init();      
    }
  }

  AjaxCart.prototype = $.extend({}, AjaxCart.prototype, {
    onSelect: function() {
      this.ajaxCart.open();
    },

    onDeselect: function() {
      this.ajaxCart.close();
    },

    onUnload: function() {
      this.ajaxCart.close();
    }
  });

  return AjaxCart;
})(jQuery);

/**
 * Cart Section Script
 * ------------------------------------------------------------------------------
 *
 * Requires slate.cartAPI
*
 * @namespace - cart
 */

theme.Cart = (function($) {

  var CartAPI = slate.CartAPI;

  var $window = $(window);

  var selectors = {
    form: '[data-cart-form]',
    cartNoteLink: '[data-cart-note-link]',
    cartNoteForm: '[data-cart-note-form]',
    itemRemove: '[data-item-remove]'
  };

  var classes = {
    hidden: 'hidden',
    isLoading: 'is-loading'
  };

  function Cart(container) {
    this.name = 'cart';
    this.namespace = '.'+this.name;

    this.$container = $(container);
    this.$form = $(selectors.form, this.$container);
    this.$cartNoteForm = $(selectors.cartNoteForm, this.$container);
    this.$cartNoteFormTextarea = this.$cartNoteForm.find('textarea');
    this.$cartNoteLink = $(selectors.cartNoteLink, this.$container);

    this.$cartNoteLink.on('click', this.onCartNoteLinkClick.bind(this));
    $(selectors.itemRemove, this.$container).on('click', this.onItemRemoveClick.bind(this));
  };

  Cart.prototype = $.extend({}, Cart.prototype, {
    onItemRemoveClick: function(e) {
      var self = this;

      var $link    = $(e.currentTarget);
      var key      = $link.data('key')
      var bundleID = $link.data('bundle-id');
      
      // We need one or the other...
      if(!(key || bundleID)) {
        return;
      }

      e.preventDefault();

      var remove = bundleID ? CartAPI.removeBundle(bundleID) : CartAPI.removeLineItem(key);

      this.$form.addClass(classes.isLoading);

      remove
        .then(function(cart){
            self.onItemRemoveSuccess(cart);
          })
    },

    onItemRemoveSuccess: function(cart) {
      location.reload();
    },

    onCartNoteLinkClick: function(e) {
      e.preventDefault();
      this.$cartNoteLink.addClass(classes.hidden);
      this.$cartNoteForm.removeClass(classes.hidden);
      this.$cartNoteFormTextarea.focus();
    }
  });

  return Cart;
})(jQuery);

/**
 * Mobile menu Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the mobile menu
 *
 * @namespace - mobileMenu
 */

theme.MobileMenu = (function($, slate) {

  var selectors = {
    toggle: '[data-mobile-menu-toggle]',
    menu: '[data-mobile-menu]',
    newsletterForm: '[data-newsletter-form]'
  };

  function MobileMenu(container) {
    var self = this;
    
    this.$container = $(container);

    this.$el     = $(selectors.menu, this.$container);
    this.$toggle = $(selectors.toggle); // Don't scope to this.$container

    this.drawer  = new slate.models.Drawer(this.$el);

    const $newsletterForm = $(selectors.newsletterForm, this.$container);

    if ($newsletterForm.length) {
      this.newsletterForm = new slate.models.NewsletterForm($newsletterForm);

      this.ajaxForm = new slate.AjaxKlaviyoForm($newsletterForm, {
        listId: $newsletterForm.data('klaviyo-list-id'),
        source: $newsletterForm.data('klaviyo-source'),
        onSubmitFail: function(errors) {
          self.newsletterForm.onSubmitFail(errors);
        },
        onSubscribeSuccess: function(response) {
          self.newsletterForm.onSubscribeSuccess(response);
        },
        onSubscribeFail: function(response) {
          self.newsletterForm.onSubscribeFail(response);
        }
      });
    }

    this.$toggle.on('click', this.onToggleClick.bind(this));
  }

  MobileMenu.prototype = $.extend({}, MobileMenu.prototype, {
    onToggleClick: function(e) {
      e.preventDefault();
      this.drawer.toggle();
    },

    onSelect: function() {
      this.drawer.show();
    },

    onDeselect: function() {
      this.drawer.hide();
    }
  });

  return MobileMenu;
})(jQuery, slate);

/**
 * Blog Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - blog
 */

theme.Blog = (function($) {

  var selectors = {
    contentGrid: '.content-grid',
    contentGridItem: '.content-grid__item',
    pagination: '[data-pagination]',
    nextPageLink: '[data-next-page]',
  };

  var classes = {
    tagIsActive: 'is-active'
  };

  function Blog(container) {

    var self = this;
    this.$container = $(container);

    this.name = 'blog';
    this.namespace = '.'+this.name;

    this.$container.on('click', selectors.nextPageLink, this.onNextPageLinkClick.bind(this));
  };

  Blog.prototype = $.extend({}, Blog.prototype, {

    onNextPageLinkClick: function(e) {
      e.preventDefault();
      var self     = this;
      var $link    = $(e.currentTarget);
      var url      = $link.attr('href');
      var linkText = $link.html();


      $.ajax({
        url: url,
        beforeSend: function( xhr ) {
          $link.html(theme.strings.loading || 'Loading');
        }
      })
      .done(function( data ) {
        var $dom = $(data);
        var $contentItems = $(selectors.contentGridItem, $dom);
        var $newNextPageLink = $(selectors.nextPageLink, $dom);

        $(selectors.contentGrid, self.$container).append($contentItems);

        if($newNextPageLink.length) {
          $link.replaceWith($newNextPageLink);
        }
        else {
          $(selectors.pagination, self.$container).remove();
        }
      });

    }
  });

  return Blog;
})(jQuery);

/**
 * Blog Media Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - blog
 */

theme.BlogMedia = (function($, slate) {

  var selectors = {
    lazyImage: '.mosaic-entry__image[data-src]',
    nextPageLink: '[data-next-page]',
    mosaic: '[data-mosaic]',
    mosaicEntry: '.mosaic-entry'
  };

  var classes = {
    mosaicImageLoaded: 'is-loaded'
  }

  var $window = $(window);

  function BlogMedia(container) {
    this.$container = $(container);

    this.name = 'blogMedia';
    this.namespace = '.'+this.name;
    this.isLoading = false;
    this.threshold = 500; // Load pages when they come within this amount of pixels
    this.measurements = {};

    this.$mosaic = $(selectors.mosaic, this.$container);
    this.$nextPageLink = $(selectors.nextPageLink, this.$container);

    this.throttledOnScroll = $.throttle(150, this.onScroll.bind(this));
    this.throttledOnResize = $.throttle(50, this.onResize.bind(this));

    this.applyUnveil();

    if(this.$nextPageLink.length) {
      window.addEventListener('scroll', this.throttledOnScroll);
      window.addEventListener('resize', this.throttledOnResize);
      this.onResize(); // Set the measurements
    }
  };

  BlogMedia.prototype = $.extend({}, BlogMedia.prototype, {
    onResize: function() {
      // Cache these measurements
      this.measurements = {
        windowHeight: $window.height(),
        containerTop: this.$container.offset().top,
        containerHeight: this.$container.height()
      }
    },

    onScroll: function(e) {
      if(this.isLoading) return;

      var scrollY = slate.utils.getScrollY();
      var scrolledFarEnough = (scrollY + this.measurements.windowHeight + this.threshold) > (this.measurements.containerTop + this.measurements.containerHeight)
      
      if(scrolledFarEnough) {
        window.removeEventListener('scroll', this.throttledOnScroll);
        
        this.fetchNextPage(function(morePostsAvailable) {
          morePostsAvailable && window.addEventListener('scroll', this.throttledOnScroll);
        }.bind(this));
      }
    },

    applyUnveil: function() {
      $lazyImages = this.$container.find(selectors.lazyImage);

      $window.off('unveil');
      $lazyImages.unveil(100, function() {
        $(this).addClass(classes.mosaicImageLoaded);
      });
    },

    fetchNextPage: function(onFetchComplete) {
      var self = this;
      var url  = this.$nextPageLink.attr('href');

      $.ajax({
        url: url,
        beforeSend: function() {
          self.isLoading = true;
        }
      })
      .done(function(data) {
        var $dom = $(data);
        var $newContentItems = $(selectors.mosaicEntry, $dom);
        var $newNextPageLink = $(selectors.nextPageLink, $dom);
        var morePostsAvailable = ($newNextPageLink.length > 0);

        $newContentItems.each(function(i, el) {
          self.$mosaic.append(el);
        });

        self.applyUnveil();

        if(morePostsAvailable) {
          self.$nextPageLink.replaceWith($newNextPageLink);
          self.$nextPageLink = $newNextPageLink;
        }
        else {
          self.$nextPageLink.remove();
        }

        if(typeof onFetchComplete === "function") {
          onFetchComplete(morePostsAvailable)
        }

        self.isLoading = false;
      });
    }
  });

  return BlogMedia;
})(jQuery, slate);


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  var selectors = {
    addressNewToggle: '[data-address-new-toggle]',
    addressEditToggle: '[data-address-edit-toggle][data-form-id]',
    addressDelete: '[data-address-delete][data-form-id]'
  };

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $(selectors.addressNewToggle).on('click', function(e) {
    e.preventDefault();
    $newAddressForm.toggleClass('hide');
  });

  $(selectors.addressEditToggle).on('click', function(e) {
    e.preventDefault();
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $(selectors.addressDelete).on('click', function(e) {
    e.preventDefault();
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
    $('#RecoverPassword').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/**
 * Styleguide Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the styleguide page template.
 *
 * Use this to hook up any JS necessary to show element functionality.
 */

 theme.styleguide = (function() {
  
  var $body = $(document.body);
  
  var selectors = {
    dot: '.dot'
  }

  if( !$body.is('#styleguide') ){
    return;
  }

  $body.on('click', selectors.dot, function(){
    $(this).toggleClass('is-active');
  });

  $body.on('click', 'a[href="#"]', function(){
    return false;
  });

})();


(function($) {
  var $window       = $(window);
  var $document     = $(document);
  var $body         = $(document.body);

  window.lazySizes && window.lazySizes.init();

  theme.SlideshowSwiper = (function($, Swiper) {
  var selectors = {
    swiper: '.js-slideshow-swiper',
    pagination: '.swiper-pagination',
    prev: '.swiper-button-prev',
    next: '.swiper-button-next'
  };

  function SlideshowSwiper(container) {
    this.$container = $(container);
    this.$swiperEl = this.$container.find(selectors.swiper);
    this.$slideshow = this.$container.find('.home-slideshow');

    if (!this.$swiperEl.length || this.$swiperEl.data('swiper-initialized')) return;
    if (typeof Swiper === 'undefined') return;

    var el = this.$swiperEl.get(0);
    var paginationEl = this.$container.find(selectors.pagination).get(0);
    var prevEl = this.$container.find(selectors.prev).get(0);
    var nextEl = this.$container.find(selectors.next).get(0);

    var autoplayDelay = parseInt(this.$slideshow.data('autoplay'), 10) || 0;
    var transition = this.$slideshow.data('transition'); // 'transition-fade' / 'transition-slide'

    var slideLen = this.$swiperEl.find('.swiper-wrapper > .swiper-slide').length;
    if (slideLen === 0) return;

    var enableControls = slideLen > 1;
    var _this = this;

    // 1枚時の識別クラス
    if (!enableControls) {
      this.$container.addClass('slideshow-single');
    } else {
      this.$container.removeClass('slideshow-single');
    }

    var options = {
      loop: enableControls,
      speed: 600,
      simulateTouch: enableControls,
      allowTouchMove: enableControls,
      effect: (transition === 'transition-fade') ? 'fade' : 'slide',
      fadeEffect: (transition === 'transition-fade') ? { crossFade: true } : undefined,
      pagination: (enableControls && paginationEl)
        ? { el: paginationEl, clickable: true }
        : undefined,
      navigation: (enableControls && prevEl && nextEl)
        ? { prevEl: prevEl, nextEl: nextEl }
        : undefined
    };

    if (enableControls && autoplayDelay > 0) {
      options.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false
      };
    }

    this.swiper = new Swiper(el, options);

    this.updateSwiperLayout = function() {
      if (!_this.swiper) return;

      _this.swiper.update();

      if (!enableControls) {
        _this.swiper.slideTo(0, 0, false);
      }
    };

    // 初回
    this.updateSwiperLayout();

    // 画像ロード後
    this.$swiperEl.find('img').each(function() {
      if (this.complete) {
        _this.updateSwiperLayout();
      } else {
        $(this).one('load', function() {
          _this.updateSwiperLayout();
        });
      }
    });

    // リサイズ時
    this._boundResizeHandler = function() {
      _this.updateSwiperLayout();
    };

    $(window).on(
      'resize.slideshowSwiper-' + this.$container.data('section-id') +
      ' orientationchange.slideshowSwiper-' + this.$container.data('section-id'),
      this._boundResizeHandler
    );

    this.$swiperEl.data('swiper-initialized', true);
  }

  SlideshowSwiper.prototype.onUnload = function() {
    var sectionId = this.$container.data('section-id');

    $(window).off(
      'resize.slideshowSwiper-' + sectionId +
      ' orientationchange.slideshowSwiper-' + sectionId
    );

    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    if (this.$swiperEl && this.$swiperEl.length) {
      this.$swiperEl.removeData('swiper-initialized');
    }

    this.$container.removeClass('slideshow-single');
  };

  SlideshowSwiper.prototype.onSelect = function() {
    if (this.updateSwiperLayout) {
      this.updateSwiperLayout();
    } else if (this.swiper) {
      this.swiper.update();
    }
  };

  return SlideshowSwiper;
})(jQuery, Swiper);

  $(document).ready(function() {
    var sections = new slate.Sections();
    sections.register('product', theme.Product);
    sections.register('product-preview', theme.ProductPreview);
    sections.register('product-display-only', theme.ProductDisplayOnly);
    sections.register('collection', theme.Collection);
    sections.register('pencil-banner', theme.PencilBanner);
    sections.register('header', theme.Header);
    sections.register('footer', theme.Footer);
    sections.register('ajax-cart', theme.AjaxCart);
    sections.register('cart', theme.Cart);
    sections.register('mobile-menu', theme.MobileMenu);
    sections.register('blog', theme.Blog);
    sections.register('blog-media', theme.BlogMedia);
    sections.register('slideshow-swiper', theme.SlideshowSwiper);


    $('.in-page-link').on('click', function(evt) {
      slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));    

    // Target tables to make them scrollable
    slate.rte.wrapTables({
      $tables: $('.rte table'),
      tableWrapperClass: 'table-responsive'
    });

    // Target iframes to make them responsive
    var iframeSelectors =
      '.rte iframe[src*="youtube.com/embed"],' +
      '.rte iframe[src*="player.vimeo"]';

    slate.rte.wrapIframe({
      $iframes: $(iframeSelectors),
      iframeWrapperClass: 'rte__video-wrapper'
    });

    // Apply UA classes to the document
    slate.utils.userAgentBodyClass();    

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.utils.cookiesEnabled()) {
      document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }

    // Chosen JS plugin for select boxes
    slate.utils.chosenSelects();

    // Add "development mode" class for CSS hook
    if (window.location.hostname === 'localhost' || window.location.hostname.indexOf('shopifypreview.com') > -1) {
      $body.addClass('development-mode');
    }
  });
}(jQuery));
